import { grey } from "@material-ui/core/colors";

const dialogWidth = {
  xs: "200px",
  sm: "350px",
  md: "350px",
  sl: "460px",
  lg: "460px",
};

// [SLB] 'sl' (theme.js:36 = 1300..1366) became reachable from useWidth() when App.js:1049
// added it to the hardcoded breakpoints.keys list. Without an entry here,
// maxDialogWidth[windowSize] is undefined and line ~200 emits "undefinedpx !important"
// on every dialog — 1366px is the most common laptop width.
const minDialogWidth = {
  xs: 330,
  sm: 330,
  md: 500,
  sl: 500,
  lg: 500,
  xl: 620,
};

const maxDialogWidth = {
  md: 1080,
  sl: 1080,
  lg: 1080,
  xl: 1080,
};

// const maxTemplateDialogWidth = {
//   xs: 330,
//   sm: 500,
//   md: 960,
//   xl: 1060,
//   lg: 1060,
// };


const summaryPadding = {
  xs: 0,
  sm: 0,
  md: 0,
  sl: 25,
  lg: 25,
  xl: 25,
};

const iconWrapperMargin = {
  xs: "10px 5px 5px",
  sm: 10,
  md: 15,
  lg: 15,
  xl: 15,
};
const iconWrapperMinWidth = {
  xs: 50,
  sm: 100,
  md: 100,
};
// const summaryNotificationMinWidth = {
//   xs: "240px",
// }
const notificationTitleFontSize = {
  xs: 12,
  sm: 12,
  md: "1rem",
};

const graphTextWidth = {
  sm: 250,
  md: 250,
  lg: 110,
  xl: 250,
};

export const getGeneralStyle = (windowSize, isRTL, theme = {}) => {
  const safeTheme = theme && typeof theme.breakpoints !== 'undefined' ? theme : { breakpoints: { down: () => '@media (max-width:0px)' }, spacing: (n) => n * 8 };
  return ({
    editAgentIconButton: {
      background: theme.palette.type === 'dark' ? theme.custom.surface : '#f5f6fa',
      borderRadius: '50%',
      boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0',
      width: 32,
      height: 32,
      padding: 4,
      minWidth: 0,
    },
  background: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -1,
    '& svg': {
      position: 'absolute',
      bottom: 0
    },
    '& .rightSvg': {
      right: 0,
      transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)'
    },
    '& .leftSvg': {
      left: 0,
      transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)'
    },
    // The decorative shapes are a hard-coded pale #F0F5FF. In dark they were only
    // hidden because index.html paints <html> dark (body's background then draws
    // over this z-index:-1 layer); without that block — as on production 2 Nov —
    // they show as light-blue patches. Hide them in dark so it no longer depends on it.
    ...(theme.palette.type === 'dark' ? { display: 'none' } : {})
  },
  appBody: {
    overflowX: 'hidden',
    '& input::placeholder': {
      color: theme.palette.type === 'dark' ? theme.custom.textSecondary : 'rgba(0,0,0,.65)',
      opacity: 1/* Firefox */
    },
    '& input::ms-input-placeholder': {
      color: theme.palette.type === 'dark' ? theme.custom.textSecondary : 'rgba(0,0,0,.65)',
    }
  },
  formControlLabelRoot: {
    alignItems: 'flex-start',
    marginTop: 0
  },
  formControlLabelAlign: {
    marginTop: 9  // This aligns the label text with the top of the checkbox
  },
  greyBackground: {
    background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#F0F5FF',
  },
  evenRowBackground: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : "#f7faff",
  },
  sidebar: {
    paddingRight: '0 !important',
    "&::-webkit-scrollbar": {
      display: "block !important",
      width: 6,
      height: 6,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 0px",
      borderRadius: 10,
      backgroundColor: theme.palette.type === 'dark' ? `${theme.custom.surface} !important` : "#fff !important",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.type === 'dark' ? '#3a3f48' : "#ccc",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.type === 'dark' ? '#4a505a' : "#999",
    },

    '& *': {
      "&::-webkit-scrollbar": {
        display: "block !important",
        width: 6,
        height: 6,
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 0px",
        borderRadius: 10,
        backgroundColor: theme.palette.type === 'dark' ? `${theme.custom.surface} !important` : "#fff !important",
      },
      "&::-webkit-scrollbar-thumb": {
        background: theme.palette.type === 'dark' ? '#3a3f48' : "#ccc",
        borderRadius: 10,
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: theme.palette.type === 'dark' ? '#4a505a' : "#999",
      },
    }
  },
  dialogCustomSize: {
    height: "40vh",
    width: windowSize === "lg" || windowSize === "xl" ? "550px" : null,
  },
  solidDialogContainer: {
    zIndex: '1500 !important',
    "& .MuiPaper-root": {
      borderRadius: 25,
      overflowX: "hidden",
      boxShadow: '5px 5px 5px rgb(0 0 0 / 35%)',
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f5f5f5',
    },
    "& .MuiDialog-paperWidthSm": {
      minWidth: minDialogWidth[windowSize],
      maxWidth: maxDialogWidth[windowSize],
    },
    "& .MuiDialog-paperScrollPaper": {
      maxHeight: '100%'
    },
  },
  dialogContainer: {
    // zIndex: "1500 !important",
    "& .MuiPaper-root": {
      overflowX: "hidden",
      // BaseDialog's Paper never set its own background — it fell through to MUI's
      // own theme.palette.background.paper, which stays frozen light for every
      // screen that hasn't migrated (see theme.js). BaseDialog is used by 140+
      // files, so it gets its own explicit dark-mode override here rather than
      // waiting for theme.palette to become mode-aware (which would break every
      // other unmigrated Paper/Card app-wide).
      ...(theme.palette.type === 'dark' ? {
        backgroundColor: theme.custom.surface,
        color: theme.custom.textPrimary,
        '& .MuiInputBase-input, & .MuiSelect-select, & .MuiOutlinedInput-input, & .MuiInput-input': {
          color: theme.custom.textPrimary,
        },
        '& .MuiFormLabel-root, & .MuiInputLabel-root, & .MuiFormHelperText-root': {
          color: theme.custom.textSecondary,
        },
      } : {}),
    },
    "& .MuiDialog-scrollPaper": {
      "@media screen and (max-width: 450px)": {
        zoom: '85%'
      },
      "@media screen and (max-width: 330px)": {
        zoom: '70%'
      }
    },
    "& .MuiDialog-paperWidthSm": {
      minWidth: 400,
      maxWidth: `${maxDialogWidth[windowSize]}px !important`,
      "@media screen and (max-width: 450px)": {
        minWidth: "unset",
        maxWidth: "96vw !important",
      },
    },
    "& .MuiDialog-paperScrollPaper": {
      maxHeight: "100%",
      borderRadius: 15
    },
  },
  noPadding: {
    padding: "0px !important",
  },
  noMargin: {
    margin: '0px !important',
  },
  newNavigationDialogContainer: {
    '&& .MuiDialog-paperWidthSm': {
      minWidth: '0 !important',
    }
  },
  // OUTER MUI paper override for the tier-graph dialog ONLY. The doubled '&&' beats
  // dialogContainer's `& .MuiDialog-paperWidthSm { maxWidth: 1080px !important }` (0,2,0) with (0,3,0),
  // lifting the 1080 cap so the outer paper is the single width source of truth. Passed as
  // customContainerStyle (BaseDialog ignores PaperProps/fullWidth). Same trick as
  // newNavigationDialogContainer above.
  // The paper now TRACKS THE IMAGE instead of always taking 94vw, so a 640px graph no longer sits in
  // wide grey margins. --tg-img-w is published on <html> by TierGraphDialog. --tg-chrome-w defaults to
  // 416px = editor panel 380 (flex-basis 380 with boxSizing:'border-box', so its own 16px padding and
  // 1px inline-start border are INSIDE the 380) + stage column padding 18*2. Nothing else contributes:
  // tierGraphDialogPaperProps / tierGraphDialogContent / tierGraphDialogChildren all force padding 0.
  // maxWidth was 75%, which BEAT the width line above and re-broke the §17 one-row header on every
  // laptop: at 1366px it capped the paper at 1024.5px, ~32px under the 1056px a default 640px graph
  // asks for, so the header wrapped again below ~1408px of viewport. 95% keeps a ceiling for large
  // graphs while letting the 94vw term above be the real cap (it is always the smaller of the two).
  tierGraphDialogContainer: {
    '&& .MuiDialog-paperWidthSm': {
      minWidth: '0 !important',
      width: 'min(calc(var(--tg-img-w, 640px) + var(--tg-chrome-w, 416px)), 94vw) !important',
      maxWidth: '95% !important',
      margin: '16px !important',
    },
    '&& .MuiDialog-paperScrollPaper': {
      maxHeight: 'calc(100% - 32px)', // leave room for the 16px top/bottom margin
    },
  },
  newNavigationDialogPaper: {
    width: 462,
    maxWidth: '96vw !important',
    minWidth: '0 !important',
    borderRadius: '15px !important',
    overflow: 'hidden',
  },
  newNavigationCloseButton: {
    position: 'absolute',
    right: isRTL ? 'initial' : 8,
    left: !isRTL ? 'initial' : 8,
    top: 8,
    background: 'transparent',
    color: '#fff',
    filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.4))',
    '&:hover': {
      background: 'rgba(255,255,255,0.15)',
    },
  },
  newNavigationDialogContent: {
    '&&': {
      border: 'none',
      margin: 0,
      padding: 0,
      minWidth: '0 !important',
    },
  },
  newNavigationDialogChildren: {
    '&&': {
      margin: 0,
      marginBlock: 0,
      marginTop: 0,
      padding: 0,
      paddingRight: '0px !important',
      paddingLeft: '0px !important',
      minWidth: '0 !important',
      overflowX: 'hidden !important',
      '&::-webkit-scrollbar': {
        display: 'none !important'
      }
    },
  },
  wizardFlex: {
    flex: 1,
    alignContent: "flex-end",
    justifyContent: "center",
  },
  dialogTitle: {
    fontSize: '1.2rem',
    fontWeight: "500",
    color: "#fff",
    paddingInline: 15,
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    direction: isRTL ? 'rtl' : 'ltr'
  },
  resetDialogTitle: {
    fontSize: "2rem",
    fontWeight: "400",
    color: theme.palette.type === 'dark' ? theme.custom.accentBlue : "#0a74a9",
    whiteSpace: "pre-line",
  },
  reducedTitle: {
    "@media screen and (max-width: 768px)": {
      fontSize: "1.3rem",
    }
  },
  packageDialogPpaper: {
    // background: '#ffe6e0c4'
  },
  dialogChildren: {
    marginBlock: 20,
    marginTop: 5,
    paddingRight: `${summaryPadding[windowSize]}px !important`,
    paddingLeft: summaryPadding[windowSize],
    overflowY: "auto",
  },
  paddingSides5: {
    paddingRight: 5,
    paddingLeft: 5,
  },
  pl10: {
    paddingLeft: 10,
  },
  pl30: {
    paddingLeft: 30,
  },
  pr30: {
    paddingRight: 30,
  },
  paddingSides10: {
    paddingRight: 10,
    paddingLeft: 10,
  },
  paddingSides15: {
    paddingRight: 15,
    paddingLeft: 15,
  },
  paddingSides25: {
    paddingRight: 25,
    paddingLeft: 25,
  },
  marginSides5: {
    marginRight: 5,
    marginLeft: 5,
  },
  marginSides10: {
    marginRight: '10px !important',
    marginLeft: '10px !important',
  },
  copyClip: {
    border: "1px solid #3476b0",
    padding: 5,
    color: "#3476b0",
    fontWeight: 600,
    backgroundColor: "#bde5f8",
    opacity: 1,
    zIndex: 10,
  },
  dialogIconContent: {
    fontFamily: "pulseemicons",
    color: "#fff",
    fontSize: 25,
    '&.unicode': {
      fontSize: 24
    }
    // padding: 5,
  },
  dialogAlertIcon: {
    fontSize: 28,
    color: "#fff",
    border: "1px solid #fff",
    borderRadius: 50,
    width: 40,
    height: 40,
  },
  switchActive: {
    color: "#27AE60",
  },
  switchInactive: {
    // Dark: lighter red so the status text meets WCAG AA on dark surfaces (#F02039 is ~3.9:1).
    color: theme.palette.type === 'dark' ? theme.custom.statusError : "#F02039",
  },
  dialogErrorText: {
    fontFamily: "Assistant",
    fontSize: 18,
  },
  boxDialog: {
    maxWidth: 380,
    marginBottom: 15,
  },
  middle: {
    alignSelf: "center",
  },
  mainContainer: {
    maxHeight: "calc(100vh - 53px)",
    overflow: "auto",
  },
  defaultScreen: {
    overflow: "visible",
    //maxHeight: 'calc(100vh - 53px)'
  },
  pulseemIcon: {
    fontFamily: "pulseemicons",
  },
  borderBottom1: {
    borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #ccc",
  },
  dFlex: {
    display: "flex",
  },
  justifyContentEnd: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  width_min_content: {
    width: 'min-content'
  },
  rtlSwitch: {
    transform: "rotateY(180deg)",
  },
  dBlock: {
    display: "block !important",
  },
  dInlineBlock: {
    display: "inline-block !important",
  },
  dNone: {
    display: "none",
  },
  borderAround: {
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #000",
  },
  greyBorderAround: {
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #d3d3d3",
  },
  alignItemsCenter: {
    alignItems: "center",
  },
  w110: {
    width: 110,
  },
  lineHeight1point2: {
    lineHeight: 1.2,
  },
  w25: {
    width: 25,
  },
  minHeight50: {
    minHeight: 50,
  },
  height50: {
    height: 50,
  },
  maxHeight87: {
    maxHeight: "auto",
    "@media screen and (min-width: 600px)": {
      maxHeight: 100,
    },
  },
  w20: {
    width: "20%",
  },
  w30: {
    width: "30%",
  },
  w40: {
    width: "40%",
  },
  w80: {
    width: "80%",
  },
  w70: {
    width: "70%",
  },
  w60: {
    width: "60%",
  },
  w15VW: {
    width: "15vw",
  },
  w50VW: {
    width: "50vw",
  },
  w70VW: {
    width: "70vw",
  },
  w80VW: {
    width: "80vw",
  },
  minWidth100: {
    minWidth: 100,
  },
  width100: {
    width: 100,
  },
  maxWidth400: {
    maxWidth: 400,
  },
  maxWidth500: {
    maxWidth: 500,
  },
  maxWidth190: {
    maxWidth: 190,
  },
  minWidth70VW: {
    minWidth: '70vw',
  },
  maxWidth70VW: {
    maxWidth: '70vw',
  },
  maxWidth80VW: {
    maxWidth: '80vw',
  },
  minHeight70VH: {
    minHeight: '70vh',
  },
  width160: {
    width: 160,
    maxWidth: 160,
  },
  widthUnset: {
    width: "unset",
  },
  maxWidth540: {
    maxWidth: 540,
  },
  maxWidth900: {
    maxWidth: 900,
  },
  flex2: {
    flex: 2,
  },
  dInline: {
    display: "inline",
  },
  pl25: {
    paddingInlineEnd: 25,
  },
  pe10: {
    paddingInlineEnd: 10,
  },
  pe5: {
    paddingInlineEnd: 5,
  },
  p10: {
    padding: 10,
  },
  p50: {
    padding: 50,
  },
  pbt5: {
    padding: "5px 0",
  },
  p20: {
    padding: 20,
  },
  p0: {
    padding: 0,
  },
  plr10: {
    padding: "0 10px",
  },
  pr10: {
    paddingInlineStart: 10,
  },
  pl5: {
    paddingInlineStart: 5,
  },
  ps15: {
    paddingInlineStart: 8,
  },
  pe15: {
    paddingInlineEnd: 8,
  },
  ps25: {
    paddingInlineStart: 25,
  },
  pt0: {
    paddingTop: '0px !important',
  },
  pt2rem: {
    paddingTop: "2rem",
  },
  pt5: {
    paddingTop: 5,
  },
  pt10: {
    paddingTop: 10,
  },
  pt14: {
    paddingTop: 14,
  },
  pt15: {
    paddingTop: '15px !important'
  },
  pt25: {
    paddingTop: 25
  },
  pt30: {
    paddingTop: 30
  },
  pt50: {
    paddingTop: 50
  },
  pt90: {
    paddingTop: 90
  },
  pt2: {
    paddingTop: 1.4,
  },
  pb0: {
    paddingBottom: 0
  },
  pb5: {
    paddingBottom: 5,
  },
  pb10: {
    paddingBottom: 10,
  },
  m10: {
    margin: 10,
  },
  mr10: {
    marginInlineEnd: 10,
  },
  mb5: {
    marginBottom: 5,
  },
  mb10: {
    marginBottom: 10,
  },
  mb15: {
    marginBottom: '15px !important',
  },
  mt20: {
    marginTop: 20,
  },
  mt25: {
    marginTop: 25,
  },
  mb20: {
    marginBottom: 20,
  },
  ml25: {
    marginInlineStart: '25px !important',
  },
  mtNeg15: {
    marginTop: -15,
  },
  mbNeg10: {
    marginBottom: -10,
  },
  mleft5: {
    marginLeft: 5,
  },
  mr5: {
    marginLeft: 5,
  },
  mlr10: {
    marginInline: 10,
  },
  mlr30: {
    marginInline: 30,
  },
  ml0: {
    marginLeft: 0,
    marginInlineStart: 0,
  },
  ml5: {
    marginInline: 5,
  },
  ml10: {
    marginInlineStart: 10,
  },
  mr15: {
    marginInlineEnd: 15,
  },
  mt0: {
    marginTop: 0,
  },
  ml15: {
    marginInlineStart: 15,
  },
  mt10: {
    marginTop: '10px !important',
  },
  mt15: {
    marginTop: 15,
  },
  f12: {
    fontSize: `12px !important`,
  },
  f13: {
    fontSize: '13px !important',
  },
  mxAuto: {
    marginInline: "auto",
  },
  f14: {
    fontSize: '14px !important',
  },
  f15: {
    fontSize: 15,
  },
  f16: {
    fontSize: '16px !important',
  },
  f18: {
    fontSize: '18px !important',
  },
  f20: {
    fontSize: 20,
  },
  f22: {
    fontSize: '22px !important',
  },
  f25: {
    fontSize: 25,
  },
  f28: {
    fontSize: 28,
  },
  f30: {
    fontSize: '30px !important',
  },
  f09rem: {
    fontSize: '0.9rem'
  },
  h50v: {
    height: '50vh'
  },
  h10v: {
    height: '20vh'
  },
  line1: {
    lineHeight: 1,
  },
  colrPrimary: {
    color: '#ff3343'
  },
  bgWhite: {
    backgroundColor: theme.palette.type === 'dark' ? `${theme.custom.surface} !important` : "#ffffff !important",
  },
  bgBrown: {
    backgroundColor: "#636363",
  },
  colorWhite: {
    color: "#fff !important",
  },
  colorGray: {
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : "rgba(0,0,0,0.40)",
  },
  colorBlue: {
    color: theme.palette.type === 'dark' ? theme.custom.accentBlue : "#0371AD",
  },
  bgGreen: {
    backgroundColor: "green",
  },
  inlineGrid: {
    display: "inline-grid",
  },
  bgLightGray: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : "rgba(242, 242, 242, 1)",
  },
  borderRadius30: {
    borderRadius: "30px",
  },
  justifyBetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  justifyEvenly: {
    display: "flex",
    justifyContent: "space-evenly",
  },
  tabText: {
    fontSize: 20,
    textTransform: "capitalize",
    padding: '5px 20px',
    minWidth: 150,
    minHeight: 40,
  },
  flexColumn2: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 14,
    paddingInlineEnd: 10,
  },
  txtCenter: {
    textAlign: "center",
    "& input": {
      textAlign: "center",
    },
  },
  bold: {
    fontWeight: "bold",
  },
  semibold: {
    fontWeight: 500,
  },
  semibold600: {
    fontWeight: 600,
  },
  disabled: {
    opacity: theme.palette.type === 'dark' ? ".45" : ".65",
    pointerEvents: "none !important",
    cursor: "not-allowed !important",
  },
  imageInfo: {
    backgroundColor: "rgba(255,255,255,.5)",
    color: theme.palette.type === 'dark' ? `${theme.custom.textPrimary} !important` : "#000 !important",
  },
  alignCenter: {
    display: "flex",
    alignContent: "center",
  },
  justifyCenterOfCenter: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    alignItems: "center",
  },
  spaceBetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  mobileColumn: {
    '@media screen and (max-width: 1024px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      height: 'auto',
      gap: 6,
    },
  },
  spaceEvenly: {
    display: "flex",
    justifyContent: "space-evenly",
  },
  textCapitalize: {
    textTransform: "capitalize",
  },
  textUppercase: {
    textTransform: "uppercase !important",
  },
  noborder: {
    border: "none",
  },
  floatRight: {
    float: "right",
  },
  floatLeft: {
    float: "left",
  },
  wordBreak: {
    wordBreak: "break-all",
  },
  posRelative: {
    position: "relative",
  },
  posAbsolute: {
    position: "absolute",
  },
  iconsFont: {
    fontFamily: "pulseemicons",
    fontSize: 22,
  },
  pageSubTitle: {
    marginTop: 5,
    fontSize: 28,
  },
  subTitle: {
    margin: "0 10px !important",
    // color: "#157eaf",
    color: '#FF0054',
    fontSize: 30,
  },
  packageBoxTitle: {
    color: "#fff",
  },
  packagePriceText: {
    color: "rgb(204, 255, 0)",
  },
  blue: {
    color: "#FF0054",
  },
  bgLightBlue: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : "#E3E9F0",
  },
  bgBlack: {
    backgroundColor: "black",
  },
  fBlack: {
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : "black",
  },
  black: {
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : "#626262",
  },
  white: {
    color: "white",
  },
  whiteBox: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : "#fff",
    boxShadow: "0px 0px 10px 3px rgba(0, 0, 0, .2)",
    padding: 5,
  },
  packageBox: {
    borderRadius: 30,
    // background: 'linear-gradient(145deg, #fff3f3, #ffc2b0)',
    background: 'linear-gradient(0deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
    boxShadow: '5px 5px 10px #999999, -5px -5px 10px #ffffff',
    padding: 5,
  },
  packageBoxQty: {
    color: '#fff',
    fontSize: '1.1rem',
    fontWeight: '600'
  },
  mt1: {
    marginTop: 5,
  },
  mt2: {
    marginTop: 10,
  },
  mt3: {
    marginTop: 15,
  },
  mt4: {
    marginTop: 20,
  },
  mt5: {
    marginTop: 25,
  },
  mt6: {
    marginTop: 30,
  },
  mt50: {
    marginTop: 50
  },
  mb1: {
    marginBottom: 5,
  },
  mb2: {
    marginBottom: 10,
  },
  mb3: {
    marginBottom: 15,
  },
  mb4: {
    marginBottom: 20,
  },
  mb8: {
    marginBottom: 40,
  },
  mb50: {
    marginBottom: 50,
  },
  mb75: {
    marginBottom: 75,
  },
  m5: {
    margin: ".5rem",
  },
  font12: {
    fontSize: 12,
  },
  font13: {
    fontSize: 13,
  },
  font14: {
    fontSize: 14,
  },
  font15: {
    fontSize: 15,
  },
  font16: {
    fontSize: 16,
  },
  font18: {
    fontSize: 18,
  },
  font20: {
    fontSize: 20,
  },
  font24: {
    fontSize: 24,
  },
  linkNoDesign: {
    textDecoration: "none",
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : "black",
  },
  font30: {
    fontSize: 30,
  },
  w35: {
    width: '35%'
  },
  w50: {
    width: '50%'
  },
  directionRTL: {
    direction: 'rtl',
  },
  directionLTR: {
    direction: 'ltr',
  },
  wAuto: {
    width: 'auto'
  },
  w100: {
    width: '100% !important'
  },
  h100: {
    height: '100%'
  },
  hAuto: {
    height: 'auto !important'
  },
  pRelative: {
    position: 'ralative'
  },
  borderBox: {
    // border: "3px solid #0371ad",
    margin: "1rem",
    display: "flex",
    padding: "1rem",
    borderRadius: 5,
    flexDirection: "column",
  },
  whiteLink: {
    cursor: "pointer",
    color: "#fff",
    textTransform: "capitalize",
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    textDecoration: "underline",
  },
  blackDivider: {
    height: 2,
    backgroundColor: "rgb(0, 0, 0, 0.5)",
    textDecoration: "none",
    color: "#fff",
    textTransform: "capitalize",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  blueLink: {
    color: theme.palette.type === 'dark' ? theme.custom.accentBlue : '#0371ad',
    textTransform: 'capitalize',
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  size150: {
    width: 127,
    height: 127,
  },
  size130: {
    width: 110,
    height: 110,
  },
  noWrap: {
    flexWrap: "nowrap",
  },
  flexWrap: {
    flexWrap: "wrap",
  },
  infoDiv: {
    height: "100px",
    display: "flex",
    alignItems: "center",
    "@media screen and (max-width: 540px)": {
      width: "100%",
      height: "auto",
      marginTop: 10,
    },
  },
  headInfo: {
    fontSize: "32px",
    fontWeight: "600",
    marginInlineEnd: "10px",
    "@media screen and (max-width: 768px)": {
      fontSize: "26px",
    },
  },
  bodyInfo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "20px",
    height: "20px",
    backgroundColor: "black",
    borderRadius: "50%",
    color: "white",
    cursor: "pointer",
  },
  noBorderOnLastCell: {
    borderInlineEnd: 'none',
  },
  shortcutIcon: {
    position: 'absolute',
    padding: '10px'
  },
  headNo: {
    backgroundColor: "#1c82b2",
    color: "#fff",
    fontSize: "25px",
    border: "1px solid",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginInlineEnd: "10px",
    "@media screen and (max-width: 768px)": {
      width: "30px",
      fontSize: "24px",
      height: "30px",
    },
  },
  headDiv: {
    height: "60px",
    display: "flex",
    alignItems: "center",
  },
  contentHead: {
    color: "#ff3343",
    fontSize: "30px",
    "@media screen and (max-width: 768px)": {
      fontSize: "24px",
    },
  },
  fieldDiv: {
    // height: "100px",
    marginTop: "20px",
    // "@media screen and (max-width: 960px)": {

    //   height: "0"

    // },
  },
  btn: {
    padding: '2px 10px',
    fontWeight: 'bold',
    background: theme.palette.type === 'dark' ? 'transparent' : '#fff',
    // maxWidth: 300,
    minHeight: 34,
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
    '& path': {
      stroke: 'inherit',
    },
    "@media screen and (max-width: 400px)": {
      '& .MuiButton-startIcon': {
        width: 'initial'
      }
    },
    // Dark: at rest a secondary (ghost) action — neutral outline and light text, so it doesn't
    // compete with the primary CTA. Hover keeps the same gradient feedback as light mode, using
    // the narrower dark gradient.
    '&:hover': theme.palette.type === 'dark' ? {
      background: theme.custom.brandGradient,
      borderColor: 'transparent',
      color: '#fff',
      '& svg': {
        color: '#fff',
        fill: '#fff'
      }
    } : {
      background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
      color: '#fff',
      '& svg': {
        color: '#fff',
        fill: '#fff'
      }
    },
    border: `2px solid ${theme.palette.type === 'dark' ? theme.custom.borderControl : '#F65026'}`,
    '& svg': {
      '&:hover': {
        color: '#fff',
        fill: '#fff'
      }
      // marginLeft: 5,
      // color: '#000'
    },
    '& .MuiButton-startIcon': {
      marginTop: '-2px',
      width: 30,
      '& svg': {
        fontSize: 20
      },
      "@media screen and (max-width: 475px)": {
        width: 'auto',
        marginRight: 0
      }
    },
    '& .MuiButton-endIcon': {
      width: 30
    }
  },
  greenButton: {
    borderColor: '#5db85b',
    backgroundColor: '#5db85b',
    '&:hover': {
      background: '#5db85b',
    }
  },
  redButton: {
    borderColor: '#FF3343',
    background: theme.palette.type === 'dark' ? theme.custom.brandGradient : 'linear-gradient(90deg, #FF0076 1.31%, #FF0054 33.07%, #FF4D2A 134.74%)',
    color: '#fff',
    border: `2px solid ${theme.palette.type === 'dark' ? theme.custom.accentOutline : '#F65026'}`,
    '&:hover': {
      // background: 'linear-gradient(90deg, #FF0076 1.31%, #FF0054 33.07%, #FF4D2A 134.74%)',
      background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
      // maxWidth: 300,
      minHeight: 34,
      color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
      '& svg': {
        fill: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
      },
      '& path': {
        stroke: 'inherit'
      },
      '& path:nth-of-type(2)': {
        fill: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
      }
    },
  },
  redButtonLink: {
    // borderColor: '#FF3343',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#FFF',
    color: '#FF3343',
    '&:hover': {
      background: '#FF3343',
      color: '#fff'
    },
  },
  btnNohover: {
    '&:hover': {
      background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
      '& svg': {
        color: '#FF0054'
      }
    },
  },

  btnDisabled: {
    opacity: 0.7,
    pointerEvents: 'none'
  },
  btnRounded: {
    borderRadius: 20,
  },
  btnStepActive: {
    background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%) !important',
    color: '#fff !important',
    '& svg': {
      color: '#fff !important',
      fill: '#fff !important',
    },
    '&:hover': {
      background: 'linear-gradient(90deg, #cc005e 0%, #cc0043 23.8%, #cc3d21 100%) !important',
      color: '#fff !important',
      '& svg': {
        color: '#fff !important',
        fill: '#fff !important',
      },
    },
  },
  buttonForm: {
    display: "flex",
    flexDirection: "column",
  },
  buttonHead: {
    fontSize: "20px",
    marginBottom: "10px",
    // "@media screen and (max-width: 414px)": {
    //   fontSize: 16
    // }
  },
  buttonContent: {
    fontSize: 14,
  },
  closeModalButton: {
    position: "absolute",
    right: isRTL ? 'initial' : 0,
    left: !isRTL ? 'initial' : 0,
    top: 0,
    background: theme.palette.type === 'dark' ? theme.custom.surface : "#fff",
  },
  lightGreenButton: {
    background: '#beff00',
    border: theme.palette.type === 'dark' ? `solid 2px ${theme.custom.border}` : 'solid 2px #000',
    boxShadow: '0px 0px 2px 0px #000',
    padding: '0px 20px',
    '&:hover': {
      background: '#89b800',
      color: '#000',
      '& svg': {
        color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
        fill: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
      }
    },
  },
  alertMsg: {
    color: "#ca332f",
  },
  buttonField: {
    // borderRadius: "5px",
    // border: "1px solid #bbb",
    outline: "none",
    padding: "8px 12px 8px 4px",
    fontSize: "16px",
    "&::placeholder": {
      fontSize: "16px",
    },
  },
  buttonFieldRemoval: {
    borderRadius: "5px",
    // border: "1px solid #bbb",
    maxWidth: '100px !important',
    outline: "none",
    padding: "8px",
    width: 100,
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : "#e9ecef",
    "&::placeholder": {
      fontSize: "16px",
    },
    "& .Mui-disabled": {
      color: theme.palette.type === 'dark' ? theme.custom.textPrimary : "#000",
    },
    "@media screen and  (max-width: 960)": {
      width: "100%",
    },
  },
  buttonFieldRemovalMobile: {
    borderRadius: "5px",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #bbb",
    outline: "none",
    // padding: "8px",
    "&::placeholder": {
      fontSize: "16px",
    },
    "&:disabled": {
      color: theme.palette.type === 'dark' ? theme.custom.textPrimary : "black",
    },
  },
  success: {
    borderBottom: "1px solid green",
  },
  error: {
    borderBottom: "1px solid red !important",
  },
  errorFullBorder: {
    border: "3px solid red !important",
  },
  valid: {
    borderBottom: "1px solid #008000 !important",
  },
  msgHead: {
    fontSize: "20px",
    "@media screen and (max-width: 768px)": {
      marginTop: "40px",
    },
  },
  msgArea: {
    resize: "none",
    height: "240px",
    boxSizing: "border-box",
    fontSize: "16px",
    fontFamily: "Sans-serif",
    overflow: "hidden",
    marginTop: 5,
    overflowY: "auto",
    width: "100%",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #ced4da",
    borderBottom: "none",
    outline: "none",
    padding: "10px !important",
    borderTopLeftRadius: ".25rem",
    borderTopRightRadius: ".25rem",
    // No background of its own: the browser's dark-scheme default (#3b3b3b) would show as a
    // gray band inside the dark editor box. Light mode keeps the UA default (white) as before.
    ...(theme.palette.type === 'dark' ? { backgroundColor: 'transparent', color: theme.custom.textPrimary } : {}),
    "&::placeholder": {
      color: "rgb(170, 170, 170)",
      fontSize: "16px",
    },
  },
  textarea: {
    resize: "none",
    height: "200px",
    boxSizing: "border-box",
    fontSize: "16px",
    fontFamily: "Sans-serif",
    overflow: "hidden",
    marginTop: 5,
    overflowY: "auto",
    width: "100%",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #ced4da",
    outline: "none",
    padding: "10px !important",
    borderRadius: ".25rem",
    ...(theme.palette.type === 'dark' ? { backgroundColor: theme.custom.surface, color: theme.custom.textPrimary } : {}),
    "&::placeholder": {
      color: "rgb(170, 170, 170)",
      fontSize: "16px",
    },
  },
  smallInfoDiv: {
    display: "flex",
    width: "100%",
    boxSizing: "border-box",
    position: "relative",
    top: "-4px",
    justifyContent: "flex-end",
    alignItems: "center",
    color: "#ff3343",
    fontSize: "12px",
    padding: "10px",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #ced4da",
    borderTop: "none",
  },
  funcDiv: {
    width: "100%",
    height: "auto",
    boxSizing: "border-box",
    position: "relative",
    top: "-4px",
    padding: 5,
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #ced4da",
    borderTop: "none",
    alignItems: "center",
    borderBottomLeftRadius: ".25rem",
    borderBottomRightRadius: ".25rem",
  },
  mergeGroup: {
    '& .MuiPaper-root': {
      maxWidth: 'calc(40vw)',
      width: 'calc(40vw)',
    }
  },
  templateModal: {
    // minWidth: "900px",
    minWidth: '60vw',
    '& .preview-btn': {
      height: 30,
      background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
      color: '#fff',
      fontWeight: 'bold'
    },
    '& .category-container': {
      paddingLeft: 10,
      "@media screen and (max-width: 900px)": {
        '& p': {
          fontSize: '15px !important'
        }
      },
    },
    "@media screen and (max-width: 1278px)": {
      padding: '0px 10px',
    },
    "@media screen and (max-width: 900px)": {
      '& #name, #buttons': {
        fontSize: '13px'
      }
    },
    "@media screen and (min-width: 759px) and (max-width: 1200px)": {
      '& .category-container': {
        maxWidth: '25%',
        flexBasis: '25%'
      },
      '& .template-container': {
        maxWidth: '75%',
        flexBasis: '75%'
      },
    },
    '& .template-item': {
      "@media screen and (max-width: 768px)": {
        maxWidth: '100%',
        flexBasis: '100%'
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxWidth: '50%',
        flexBasis: '50%'
      },
      "@media screen and (min-width: 1024px) and (max-width: 1200px)": {
        maxWidth: '33.33%',
        flexBasis: '33.33%'
      },
      "@media screen and (min-width: 1200px)": {
        maxWidth: '25%',
        flexBasis: '25%'
      },
    },
  },
  beeTemplate: {
    padding: '0px !important',
    margin: '0px !important',
    minHeight: 'calc(70vh)',
    minWidth: 'calc(90vh)',
    '& .dialogChildren': {
      paddingLeft: 0,
      paddingRight: 0,
    },
    "& .MuiDialog-paperWidthSm": {
      minWidth: `70vw !important`,
      maxWidth: `70vw !important`,
    },
  },
  templateItem: {
    border: theme.palette.type === 'dark' ? `solid 1px ${theme.custom.border}` : 'solid 1px #000',
    padding: 0,
    textAlign: 'center',
    borderRadius: 3,
    height: '200px',
    minHeight: '200px',
    maxHeight: '200px',
    overflow: 'hidden',
    transition: 'all 0.1s ease',
    '& label': {
      zoom: '25%',
      pointerEvents: 'none'
    },
    "&.selected": {
      border: "solid 5px #ff3343"
    }
  },
  removeTemplateItem: {
    position: 'absolute',
    top: 6,
    color: '#FFF',
    right: isRTL ? 'auto' : 15,
    left: isRTL ? 25 : 'auto',
    background: 'red',
    padding: '2px 5px 0px 5px',
    borderRadius: 5,
    fontSize: '1.2rem',
    cursor: 'pointer',
    '& svg': {
      marginInline: 2,
    },
    zIndex: 100
  },
  baseButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    height: "100%",
    borderInlineEnd: "1px solid grey",
    "@media screen and (max-width: 768px)": {
      borderInlineEnd: 'none'
    },
    "@media screen and (max-width: 540px)": {
      flexDirection: "column-reverse",
      paddingInlineEnd: "8px",
    },
  },
  infoButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 20,
    fontWeight: 600,
    fontSize: 14,
    color: "white",
    padding: "5px 15px 5px 15px",
    backgroundColor: "#ff3343",
    cursor: "pointer",
    border: "solid 1px #ff3343",
    textTransform: "none",
    [safeTheme.breakpoints.down("xs")]: {
      width: 'auto !important',
      margin: '5px !important',
      fontSize: '14px !important',
      padding: '5px 10px !important',
    },
    "&$disabled": {
      cursor: "not-allowed !important",
    },
    "&:hover": {
      backgroundColor: "#ff334",
      border: 'solid 1px #ff3343',
      color: '#ff3343',
      "& *": {
        color: '#ff3343'
      }
    },
    "&:first-child": {
      marginInlineStart: 5,
      marginInlineEnd: 5,
    },
    "&:nth-child(2)": {
      marginInlineStart: 0,
      marginInlineEnd: 5,
    },
    "&:nth-child(3)": {
      marginInlineStart: 0,
      marginInlineEnd: 5,
    },
    "@media screen and (max-width: 1366px)": {
      fontSize: 11,
    },
    "@media screen and (max-width: 768px)": {
      width: "110px",
      padding: "8px",
      marginBottom: 5,
      fontSize: 11,
    },
    "@media screen and (max-width: 530px)": {
      "&:first-child": {
        marginInlineStart: 0,
        marginInlineEnd: 0,
      },
      "&:nth-child(2)": {
        marginInlineStart: 0,
        marginInlineEnd: 0,
      },
    },
    "@media screen and (max-width: 375px)": {
      "&:first-child": {
        marginInlineStart: 5,
        marginInlineEnd: 0,
      },
      "&:nth-child(2)": {
        marginInlineStart: 5,
        marginInlineEnd: 0,
      },
    },
  },
  selectMsg: {
    height: "100%",
    borderInlineEnd: "1px solid grey",
    display: "flex",
    alignItems: "center",
    paddingLeft: 20,
    paddingRight: 20,
    "@media screen and (max-width: 1366px)": {
      paddingLeft: 5,
      paddingRight: 0,
    },
    "@media screen and (max-width: 768px)": {
      borderRight: "none",
      borderLeft: "none",
    },
  },
  selectGroupDiv: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
    "@media screen and (max-width: 450px)": {
      width: "calc(100% - 50px)",
    },
  },
  selectVal: {
    outline: "none",
    padding: "10px",
    width: "100%",
    minWidth: 150,
    marginInlineEnd: "5px",
    marginInlineStart: "5px",
    borderRadius: "5px",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #ced4da",
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : "#fff",
    "@media screen and (max-width: 1366px)": {
      minWidth: 130,
    },
    "@media screen and (max-width: 768px)": {
      width: "100%",
      marginTop: "8px",
    },
  },
  sortBySelect: {
    width: 200,
    paddingLeft: 5,
    color: theme.palette.type === 'dark' ? `${theme.custom.textPrimary} !important` : '#000 !important',
    '& #groupOrder': {
      padding: '5px !important',
      border: 'none',
    },
    '& fieldset': {
      border: 'none',
    }
  },
  addDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    cursor: "pointer",

    width: "80px",
  },
  addButtons: {
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    fontWeight: "600",
    "@media screen and (max-width: 768px)": {
      padding: "5px",
    },
  },
  rightForm: {
    display: "flex",
    alignItems: "center",
  },
  rightInput: {
    outline: "none",
    padding: "10px",
    width: "220px",
    height: "23px",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #BBBBBB",
    borderRadius: "4px",
    marginInlineEnd: "5px",
    "@media screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  descSwitch: {
    width: "200px",
    fontSize: "15px",
    marginTop: "5px",
    color: "#C2C2C2",
    fontWeight: "600",
    "@media screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  rightSend: {
    display: "flex",
    width: "70px",
    border: "1px solid green",
    color: "green",
    height: "25px",
    padding: "9px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    cursor: "pointer",
  },
  rightInput2: {
    outline: "none",
    padding: "10px",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #efefef",
    width: "240px",
    marginInlineEnd: "5px",
    "@media screen and (max-width: 768px)": {
      width: "100%",
    },
  },

  buttonDiv: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    bottom: "10px",
    marginBottom: "40px",
    "@media screen and (max-width: 768px)": {
      flexDirection: "column-reverse",
    },
  },
  buttonDivAct: {
    position: "relative",
    bottom: "10px",
    display: "flex",
    alignItems: "center",

    marginBottom: "40px",
    "@media screen and (max-width: 768px)": {
      flexDirection: "column-reverse",
    },
  },
  rightInput3: {
    outline: "none",
    padding: "10px",
    marginInlineEnd: "15px",
    borderRadius: "30px",
    width: "50px",
    cursor: "pointer",
    height: "40px",
    boxShadow: "0 1px 2px #a5a2a2",
    border: "0",
    borderColor: "#dc3545",
    backgroundImage: "linear-gradient(180deg,#d9534f 0,#c9302c)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    "@media screen and (max-width: 768px)": {
      marginInlineEnd: "0px",
      height: "30px",
      width: "90%",
      marginBottom: "8px",
    },
  },
  rightInput4: {
    outline: "none",
    padding: "10px",
    marginInlineEnd: "15px",
    borderRadius: "30px",
    cursor: "pointer",
    height: "40px",
    boxShadow: "0 1px 2px #a5a2a2",
    border: "0",
    width: "80px",
    borderColor: "#5b9bcd",
    background: "linear-gradient(180deg,#5b9bcd 0,#4678a3)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    "@media screen and (max-width: 768px)": {
      marginInlineEnd: "0px",
      height: "30px",
      width: "90%",
      marginBottom: "8px",
    },
  },
  rightInput5: {
    outline: "none",
    padding: "10px",
    marginInlineEnd: "15px",
    borderRadius: "30px",
    height: "40px",
    boxShadow: "0 1px 2px #a5a2a2",
    border: "0",
    cursor: "pointer",
    width: "80px",
    borderColor: "#5b9bcd",
    background: "linear-gradient(180deg,#5b9bcd 0,#4678a3)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    "@media screen and (max-width: 768px)": {
      marginInlineEnd: "0px",
      height: "30px",
      width: "90%",
      marginBottom: "8px",
    },
  },
  rightInput6: {
    outline: "none",
    padding: "10px",
    marginInlineEnd: "12px",
    cursor: "pointer",
    borderRadius: "30px",
    height: "40px",
    boxShadow: "0 1px 2px #a5a2a2",
    border: "0",
    width: "100px",
    borderColor: "#449d44",
    backgroundImage: "linear-gradient(180deg,#5cb85c 0,#449d44)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    "@media screen and (max-width: 768px)": {
      marginInlineEnd: "0px",
      height: "30px",
      width: "90%",
      marginBottom: "8px",
    },
  },
  summaryBtn: {
    outline: "none",
    padding: "10px",
    marginInlineEnd: "12px",
    cursor: "pointer",
    borderRadius: "30px",
    height: "40px",
    boxShadow: "0 1px 2px #a5a2a2",
    border: "0",
    width: "100px",
    borderColor: "#449d44",
    // backgroundImage: "linear-gradient(180deg,#5cb85c 0,#449d44)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    "@media screen and (max-width: 768px)": {
      marginInlineEnd: "0px",
      height: "30px",
      width: "90%",
      marginBottom: "8px",
    },
  },
  phoneNumber: {
    position: "absolute",
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    top: 95,
    fontSize: 12,
    // Sits on the phone image's white screen; would otherwise inherit dark mode's light text.
    ...(theme.palette.type === 'dark' ? { color: 'rgba(0, 0, 0, 0.87)' } : {}),
    "@media screen and (max-width: 768px)": {
      top: 90,
      right: 0,
      margin: "0 auto",
      fontSize: 16,
    },
    "@media screen and (max-width: 560px)": {
      top: 100,
      fontSize: 14,
    },
    "@media screen and (max-width: 414px)": {
      top: 73,
      fontSize: 14,
    },
    "@media screen and (max-width: 375px)": {
      top: 80,
      fontSize: 12,
    },
    "@media screen and (max-width: 360px)": {
      top: 78,
      fontSize: 12,
    },
  },
  testDiv: {
    marginInlineStart: "35px",
    display: "flex",
    marginTop: "20px",
    "@media screen and (max-width: 768px)": {
      marginInlineStart: "0px",
    },
  },
  testRadios: {
    marginTop: "10px",
    marginInlineStart: "35px",
    "@media screen and (max-width: 768px)": {
      marginInlineStart: "0px",
    },
  },
  phoneNumberSumm: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    top: "92px",
    marginInlineStart: "133px",
    fontSize: "15px",
  },
  // phoneNumberSum: {
  //   top: "24%",
  //   left: "38%",
  //   position: "absolute",
  //   fontWeight: "700",
  //   fontSize: "15px",
  // },
  chat: {
    backgroundColor: "#3da6f6",
    color: "#fff",
    maxWidth: "260px",
    backgroundAttachment: "fixed",
    minWidth: "100px",
    padding: "8px",
    minHeight: "30px",
    wordBreak: "break-all",
    borderRadius: "12px",
    fontWeight: "500",
    maxHeight: "200px",
    "@media screen and (max-width: 768px)": {
      top: "180px",
      bottom: "0",
      left: "50px",
      right: "0",
    },
    "@media screen and (device-width: 360px)": {
      top: "180px",
      bottom: "0",
      left: "40px",
      right: "0",
    },
    "@media screen and (device-width: 411px)": {
      top: "180px",
      bottom: "0",
      left: "65px",
      right: "0",
    },
    "@media screen and (device-width: 414px)": {
      top: "180px",
      bottom: "0",
      left: "65px",
      right: "0",
    },
    "@media screen and (device-width: 320px)": {
      top: "180px",
      bottom: "0",
      left: "20px",
      right: "0",
    },
    "&:before": {
      content: "",
      position: "absolute",
      zIndex: 0,
      bottom: 0,
      right: "-8px",
      height: "20px",
      width: "20px",
      background: "#3da6f6",
      backgroundAttachment: "fixed",
      bordeBottomLefRadius: "15px",
    },
    "&:after": {
      content: "",
      position: "absolute",
      zIndex: "1",
      bottom: "0",
      right: "-10px",
      width: "10px",
      height: "20px",
      background: "#fff",
      borderBottomLeftRadius: "10px",
    },
  },
  wrapChatSumm: {
    position: "absolute",
    top: "130px",
    left: "13%",
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : "#fff",
    color: "#fff",
    borderRadius: "12px",
    height: "200px",
    overflowY: "auto",
    width: "260px",
    wordBreak: "break-all",
    "&::-webkit-scrollbar": {
      visibility: "hidden",
      width: "0px",
    },
  },
  chatBox: {
    display: "flex",
    justifyContent: isRTL ? "flex-start" : "flex-end",
    wordBreak: "break-all",
  },
  chatBoxHe: {
    display: "flex",
    wordBreak: "break-all",
  },
  wrapChat: {
    position: "absolute",
    top: "115px",
    width: 'calc(100% - 110px)',
    height: 240,
    left: "auto",
    right: 45,
    wordBreak: "break-all",
    color: "#fff",
    borderRadius: "12px",
    overflowY: "auto",
    padding: 10,
    // "@media screen and (max-width: 1530px)": {
    //   width: 308
    // },
    // "@media screen and (max-width: 1430px)": {
    //   right: 50,
    // },
    // "@media screen and (max-width: 1366px)": {
    //   width: 270,
    // },
    "@media screen and (max-width: 1260px)": {
      top: 125,
      // right: 50,
    },
    "@media screen and (max-width: 768px)": {
      // right: 45,
      // width: 250,
      height: 230,
    },

    "@media screen and (max-width: 414px)": {
      top: 100,
      right: 30,
      width: 'calc(100% - 82px)',
      height: 160,
    },
    "@media screen and (max-width: 360px)": {
      top: 105,
      right: 38,
      width: 'min-content',
      height: 'auto',
    },
    "@media screen and (max-width: 320px)": {
      top: 90,
      right: 38,
      left: "auto",
      width: 'min-content',
      height: 'auto',
    },
  },
  fromMe: {
    alignSelf: "flex-end",
    borderRadius: "1.15rem",
    lineHeight: "1.25",
    // maxWidth: '79%',
    minHeight: "53px",
    padding: "0.5rem .875rem",
    position: "relative",
    minWidth: 200,
    wordWrap: "break-word",
    backgroundColor: "#3da6f6",
    color: "#fff",
    fontSize: 16,
    "& p": {
      wordBreak: "break-word",
    },
    "&::before": {
      borderBottomLeftRadius: "0.8rem 0.7rem",
      borderRight: "1rem solid #3da6f6",
      right: "-0.35rem",
      transform: "translate(0, -0.1rem)",
      bottom: "-0.1rem",
      content: `''`,
      height: "1rem",
      position: "absolute",
    },
    "&::after": {
      backgroundColor: "#fff",
      borderBottomLeftRadius: "0.5rem",
      right: "-40px",
      transform: "translate(-30px, -2px)",
      width: "10px",
      bottom: "-0.1rem",
      content: `''`,
      height: "1rem",
      position: "absolute",
    },
    "@media screen and (max-width: 414px)": {
      minWidth: 150,
    },
    "@media screen and (max-width: 360px)": {
      minWidth: 140,
    },
  },
  groupName: {
    display: "block",
    fontSize: "32px",
    width: "100%",
    "@media screen and (max-width: 768px)": {
      width: "100%",
      fontSize: "22px",
      textAlign: 'start'
    },
  },
  fieldsRequire: {
    fontSize: "18px",
    color: theme.palette.type === 'dark' ? theme.custom.statusError : "red",
    fontWeight: "400",
    "& li": {
      marginTop: 5,
    },
    "@media screen and (max-width: 768px)": {
      fontSize: "12px !important",
      marginBottom: "4px",
    },
  },
  baseDialogSetup: {
    height: "60px",
    borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #DEE2E7",
    "@media screen and (max-width: 768px)": {
      height: "auto",
    },
  },
  bodyTextDialog: {
    fontSize: "22px",
    marginTop: "5px",
    "@media screen and (max-width: 768px)": {
      fontSize: "16px",
    },
  },
  modalDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "700px",
    marginTop: "20px",
  },
  modalSearch: {
    width: "100%",
    padding: "10px",
    outline: "none",
  },
  confirmButton: {
    outline: "none",
    padding: "10px",
    borderRadius: "30px",
    height: "30px",
    boxShadow: "0 1px 2px #a5a2a2",
    border: "0",
    width: "130px",
    borderColor: "#449d44",
    backgroundColor: "#449d44",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    marginTop: "20px",
  },
  cancelBtn: {
    outline: "none",
    padding: "10px",
    borderRadius: "30px",
    height: "30px",
    boxShadow: "0 1px 2px #a5a2a2",
    border: "0",
    width: "130px",
    borderColor: "#c9302c",
    backgroundColor: "#c9302c",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    marginTop: "20px",
  },
  saveButton: {
    outline: "none",
    padding: "10px",
    borderRadius: "30px",
    height: "30px",
    boxShadow: "0 1px 2px #a5a2a2",
    border: "0",
    width: "130px",
    borderColor: "#4678a1",
    backgroundColor: "#4678a1",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    marginTop: "20px",
  },
  dropDiv: {
    position: "absolute",
    width: "200px",
    height: "150px",
    top: "-150px",
    left: "20px",
    display: "flex",
    flexDirection: "column",
    "@media screen and (max-width: 768px)": {
      top: "40px",
      left: "0",
      right: "0",
      bottom: "0",
      width: "100%",
      zIndex: "999",
    },
  },
  dropCon: {
    cursor: 'pointer',
    marginBottom: "8px",
    border: "1px solid #ff3343",
    boxShadow: "0 3px 5px 1px #e0dada",
    borderRadius: "15px",
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : "#fff",
    padding: "10px",
    width: "100%",
    color: "#ff3343",
    textAlign: "center",
  },
  listDiv: {
    height: "300px",
    maxHeight: "200px",
    width: "100%",
    overflowX: "hidden",
    marginTop: "20px",
    overflow: "auto",
  },
  listDivFilter: {
    height: 130,
    width: "100%",
    overflowY: "auto",
    borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #efefef",
    borderLeft: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #efefef",
    borderRight: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #efefef",
    marginTop: "0",
  },
  searchCon: {
    padding: 5,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: '100%',
    "&:hover": {
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : "#efefef",
    },
    '@media screen and (max-width: 414px)': {
      top: 120,
      right: 42
    },
    '@media screen and (max-width: 360px)': {
      top: 105,
      right: 38
    },
    '@media screen and (max-width: 320px)': {
      top: 90,
      right: 38,
      left: 'auto'
    },
  },
  conInfo: {
    fontSize: "22px",
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : "#555",
    marginInlineEnd: "5px",
    [safeTheme.breakpoints.down("xs")]: {
      fontSize: 18,
      paddingTop: 5,
      paddingBottom: 10
    },
  },
  tabDiv: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    minHeight: 40

    // "@media screen and (max-width: 768px)": {
    //   width: "315px",
    // },
    // "@media screen and (device-width: 411px)": {
    //   width: "355px",
    // },
  },
  directSendTab: {
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "19px",
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : "#777777",
    width: 120,
    cursor: 'pointer',
    borderBottom: '4px solid transparent',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    "@media screen and (max-width: 768px)": {
      fontSize: "14px",
    },
    [safeTheme.breakpoints.down('xs')]: {
      fontSize: '15px !important',
      width: 80,
      height: 30,
    },
  },
  tab1: {
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "19px",
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : "#777777",
    width: '100%',
    cursor: 'pointer',
    borderBottom: '4px solid transparent',
    "@media screen and (max-width: 768px)": {
      fontSize: "14px",
    },
    [safeTheme.breakpoints.down('xs')]: {
      fontSize: '15px !important'
    },
  },
  tablistRoot: {
    '& .MuiTabs-fixed': {
      '& .MuiTabs-flexContainer': {
        height: '100%',
        background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#fff',
        borderRadius: 10,
        borderBottomRightRadius: theme.palette.type === 'dark' ? 10 : 0,
        // No extra padding/gap in dark: the row must keep light mode's exact size, or it
        // overflows the auto-scrolling scroller and shows scrollbars.
      },
    },
    '& .MuiTabs-scroller': {
      overflow: 'auto !important'
    }
  },
  btnTab: {
    fontSize: 20,
    textTransform: "capitalize",
    minWidth: 100,
    height: 'auto',
    // color: '#ff2c44',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    background: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#e4e4e4',
    marginLeft: 2,
    marginRight: 2,
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#000',
    ...(theme.palette.type === 'dark' ? { borderRadius: 7 } : {}),
    // border: '1px solid rgba(0,0,0,.125)',
    borderBottom: 0,
    // Dark only: a hairline so inactive tabs read as distinct buttons, as light's gray boxes do.
    ...(theme.palette.type === 'dark' ? { border: '1px solid rgba(255, 255, 255, 0.12)' } : {}),
    '&.alignCenter': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    [safeTheme.breakpoints.down("xs")]: {
      minWidth: 'auto',
      fontSize: 16,
    },
  },
  currentActiveTab: {
    borderBottom: theme.palette.type === 'dark' ? 'none !important' : '4px solid #ff2c44 !important',
    background: 'linear-gradient(90deg, #FF0076 1.31%, #FF0054 33.07%, #FF4D2A 134.74%)',
    color: '#fff !important',
    '& svg': {
      color: '#fff',
    },
    // Dark: a selected state, not a CTA — pink tint and outline instead of the gradient fill.
    ...(theme.palette.type === 'dark' ? {
      background: theme.custom.brandTint,
      borderColor: theme.custom.brandPrimary,
      color: `${theme.custom.brandPrimary} !important`,
      '& svg': {
        color: theme.custom.brandPrimary,
      },
    } : {}),
  },
  activeTab: {
    borderBottom: '4px solid #ff2c44 !important',
    color: "#ff2c44 !important",
  },
  "@media screen and (max-width: 768px)": {
    width: "100%",
    marginInlineStart: "0px",
    // marginBottom:"30px"
  },
  phoneDiv: {
    position: 'relative',
    maxHeight: '100%',
    overflowY: 'clip',
    "@media screen and (max-width: 960px)": {
      marginTop: 0,
    },
    "@media screen and (max-width: 768px)": {
      marginTop: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media screen and (max-width: 566px)": {
      marginTop: 25,
    },
  },
  groupsMan: {
    width: "700px",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #efefef",
    padding: "4px",
    "@media screen and (max-width: 768px)": {
      width: "315px",
    },
    "@media screen and (device-width: 411px)": {
      width: "355px",
    },
  },
  groupsMan1: {
    width: "700px",
    display: "flex",
    "@media screen and (max-width: 768px)": {
      width: "315px",
      flexWrap: "wrap",
    },
    "@media screen and (device-width: 411px)": {
      width: "355px",
      flexWrap: "wrap",
    },
  },
  reciFilter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#007bff",
    border: "1px solid #007bff",
    padding: "8px",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#007bff",
      color: "#ffffff",
    },
    "@media screen and (max-width: 768px)": {
      width: "30%",
      fontSize: "14px",
    },
  },
  selectSort: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#007bff",
    border: "1px solid #007bff",
    padding: "7px",
    borderRadius: "4px",
    // width:"150px",
    outline: "none",
    height: "40px",
    fontSize: "17px",
    "&:hover": {
      backgroundColor: "#007bff",
      color: "#ffffff",
    },
    "@media screen and (max-width: 768px)": {
      width: "100%",
      fontSize: "14px",
    },
  },
  arrowSort: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#007bff",
    border: "1px solid #007bff",
    padding: "7px",
    borderRadius: "4px",
    height: "25px",
    fontSize: "17px",
    "&:hover": {
      backgroundColor: "#007bff",
      color: "#ffffff",
    },
  },
  selectedContact: {
    width: "700px",
    maxWidth: "700px",
    height: "50px",
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : "#efefef",
    maxHeight: "50px",
    display: "flex",
    flexWrap: "wrap",
    overflowY: "auto",
    "@media screen and (max-width: 768px)": {
      width: "315px",
      fontSize: "14px",
    },
    "@media screen and (device-width: 411px)": {
      width: "355px",
      fontSize: "14px",
    },
  },
  bubble: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#007bff",
    height: "24px",
    color: "#ffffff",
    width: "70px",
    borderRadius: "20px",
    fontSize: "16px",
    margin: "6px",
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "20px",
    padding: "12px",
    "&:hover": {
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : "#efefef",
    },
  },
  graphCampaignName: {
    fontWeight: "bold",
    maxWidth: graphTextWidth[windowSize],
    // Dark: titles read as neutral text; brand color + underline only on hover/focus.
    ...(theme.palette.type === 'dark' ? {
      color: theme.custom.textPrimary,
      '&:hover, &:focus-visible': {
        color: theme.custom.brandPrimary,
        textDecoration: 'underline',
      },
    } : {}),
  },
  greyButtonWithRoundCorder: {
    background: '#535353',
    color: '#fff',
    borderRadius: '20px'
  },
  mt24: {
    marginTop: 24,
  },
  mb25: {
    marginBottom: 25,
  },
  fullSize: {
    height: "100%",
    width: "100%",
  },
  baseButtonsContainer: {
    justifyContent: "flex-end",
    alignItems: "center",
    paddingTop: "15px",
    paddingBottom: 20,
    width: "100%",
    display: "flex",
    marginTop: "auto",
    "@media screen and (max-width: 768px)": {
      flexDirection: "column-reverse",
      justifyContent: "center",
      paddingBottom: "45px",
      marginTop: "auto",
      marginBottom: "40px",
      width: "100% !important",
    },
  },
  /* Reserves room for the Nagich accessibility button, which overlaps the bottom of
     the toolbar. It is on the LEFT in BOTH directions, so the padding is physical,
     not logical: in RTL it keeps its own bottom-left default, and in LTR
     TawkToContainer.tsx pins it to `left: sidebarWidth + 5`, i.e. the left edge of
     the content area. Desktop only — below 768px the toolbar is a full-width stack
     and the global `.baseButtonsContainer *` rule overrides child widths anyway. */
  wizardActionsBar: {
    // The project has no box-sizing reset (no CssBaseline, no `*` rule in index.css), so this
    // box is content-box by default. baseButtonsContainer sets width:100%, which means a bare
    // padding-left would widen the border box past 100% and simply overflow leftward in RTL,
    // leaving the buttons exactly where they were. border-box is what makes the padding move them.
    boxSizing: "border-box",
    "@media screen and (min-width: 769px)": {
      ...(isRTL
        ? { paddingRight: 45, paddingLeft: 35 }
        : { paddingRight: 60, paddingLeft: 0 }),
    },
  },
  /* Wraps additionalButtonsOnStart so the toolbar breaks BETWEEN the two button
     clusters instead of tearing one of them in half.
     Below 768px baseButtonsContainer switches to column-reverse and reverses its
     DIRECT children; display:contents keeps these buttons direct children there,
     preserving the stacking order they had before this wrapper existed. */
  wizardStartGroup: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    flexShrink: 0,
    maxWidth: "100%",
    ...(isRTL ? { marginLeft: "auto" } : { marginRight: "auto" }),
    "@media screen and (max-width: 768px)": {
      display: "contents",
    },
  },
  /* Positioning anchor for wizardHelperText. additionalButtons always opens with the
     save button in all three Bee editors, so the caption anchored to this box's
     inline-start edge lands directly under save, in both directions. */
  wizardEndGroup: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    flexShrink: 0,
  },
  /* common.lastSaveAt caption, shown under the save button after a save.
     Absolutely positioned on purpose: it must never take part in the button row's
     inline flow. It only appears after the first save, so in the flow it widens the
     row mid-session and pushes a button onto a second line (visible at ~110% zoom).
     Branch on isRTL like the rest of this file: jss-rtl is registered in App.js but
     does NOT flip this sheet — useClasses() (classes/index.js) passes flip:false.
     Below 768px the toolbar is a vertical stack, so absolute positioning would drop
     the caption on top of the buttons underneath it — there it returns to normal
     flow and sits directly above the save button it belongs to. */
  wizardHelperText: {
    position: "absolute",
    top: "calc(100% - 6px)",
    ...(isRTL ? { right: 8 } : { left: 8 }),
    whiteSpace: "nowrap",
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 500,
    opacity: 0.6,
    pointerEvents: "none",
    animation: "$wizardHelperTextIn 0.25s ease-out",
    "@media screen and (max-width: 768px)": {
      position: "static",
      whiteSpace: "normal",
      width: "100%",
      textAlign: "center",
      fontSize: 13,
      opacity: 0.7,
      padding: "4px 0",
      animation: "none",
    },
  },
  "@keyframes wizardHelperTextIn": {
    from: { opacity: 0, transform: "translateY(-4px)" },
    to: { opacity: 0.6, transform: "none" },
  },
  flexColCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  marginLeftAuto: {
    marginLeft: "auto !important",
  },
  marginRightAuto: {
    marginRight: "auto !important",
  },
  deleteIcon: {
    color: "#fff",
    backgroundColor: "transparent",
    cursor: "pointer",
    fontSize: 28,
  },
  fullWidth: {
    maxWidth: '100% !important',
    width: "100% !important",
  },
  width90P: {
    width: "90%",
  },
  errorLabel: {
    marginTop: 8,
    color: theme.palette.type === 'dark' ? theme.custom.statusError : "red",
    fontSize: 12,
  },
  columnError: {
    borderBottom: "2px solid red",
    // padding: "4px"
  },
  modalInputForm: {
    "@media screen and (max-width: 375px)": {
      maxWidth: "calc(100% - 20px)",
    },
  },
  //#region Dialog
  dialogIconContainer: {
    paddingTop: 60,
    paddingBottom: 15,
    textAlign: "center",
    color: "#fff",
    borderRadius: 200,
    backgroundColor: "#0371ad",
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    top: -50,
  },
  dialogIconContainerRTL: {
    right: -50,
    paddingInlineEnd: 60,
    paddingInlineStart: 15,
  },
  dialogIconContainerLTR: {
    left: -50,
    paddingInlineEnd: 15,
    paddingInlineStart: 60,
  },
  solidDialogExitButton: {
    fontSize: 30,
    fontFamily: 'Assistant',
    textAlign: "center",
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : "#000",
    fontWeight: "700",
    position: "absolute",
    top: "0.5rem",
    cursor: "pointer"
  },
  dialogExitButton: {
    fontSize: 30,
    fontFamily: 'Assistant',
    textAlign: 'center',
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : 'rgba(0, 0, 0, 0.7)',
    fontWeight: '700',
    position: 'absolute',
    // top: '0.2rem',
    cursor: 'pointer',
    '& svg': {
      color: '#fff'
    }
  },
  btnBgExitDialog: {
    backgroundColor: "#0371ad",
  },
  btnNoBgExitDialog: {
    background: "none",
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : "#000"
  },
  dialogExitButtonRTL: {
    left: '1.2rem',
  },
  dialogExitButtonLTR: {
    right: '1rem',
  },
  solidDialog: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem",
    padding: "1rem",
    paddingTop: 0,
    minWidth: dialogWidth[windowSize],
    maxWidth: dialogWidth[windowSize],
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f5f5f5',
    '& .title': {
      '& p': {
        color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
        textAlign: 'center',
        fontSize: 28,
        fontWeight: 700
      }
    }
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    border: `3px solid ${theme.palette.type === 'dark' ? theme.custom.border : theme.custom.toolbarBase}`,
    borderRadius: 5,
    margin: "1rem",
    minWidth: dialogWidth[windowSize],
    "& $notification": {
      "& $iconWrapper": {
        margin: iconWrapperMargin[windowSize],
        minWidth: iconWrapperMinWidth[windowSize],
      },
      "& b, & textarea": {
        fontSize: notificationTitleFontSize[windowSize],
      },
    },
    "& $dialogChildren": {
      maxHeight:
        windowSize === "xs" || windowSize === "sm" ? "100vh" : "calc(65vh)",
      "& $phoneNumber": {
        "@media screen and (max-width: 560px)": {
          top: "70px !important",
          fontSize: 14,
        },
        "@media screen and (max-width: 414px)": {
          top: "65px !important",
          fontSize: 12,
        },
        "@media screen and (max-width: 375px)": {
          "& $phoneNumber": {
            top: 58,
            fontSize: 12,
          },
        },
      },
      "& $wrapChat": {
        "@media screen and (max-width: 560px)": {
          top: 110,
        },
        "@media screen and (max-width: 414px)": {
          top: "90px !important",
          right: 30,
          width: 190,
          height: 135,
        },
        "@media screen and (max-width: 375px)": {
          top: 75,
          right: 26,
          width: 180,
          height: 135,
        },
      },
    },
    "& $mobileBG": {
      "& $iconWrapper": {
        minWidth: windowSize === "xs" ? 0 : 100,
      },
    },
  },
  solidDialogButton: {
    fontFamily: "OpenSansHebrew",
    color: "#fff",
    textTransform: "capitalize",
    width: 120,
    fontSize: 18,
    borderRadius: 8,
    boxShadow: 'none !important',
    border: 'none !important'
  },
  dialogButton: {
    fontFamily: "OpenSansHebrew",
    color: "#fff",
    textTransform: "capitalize",
    width: 120,
    fontSize: 18,
    borderRadius: 50,
  },
  dialogButtonResponive: {
    marginInline: 10,
    "@media screen and (max-width: 768px)": {
      fontSize: 14,
      marginTop: 5,
      marginBottom: 5,
      width: 100
    },
  },
  dialogButtonCenter: {
    margin: "0 auto",
    height: 40,
    fontSize: 18,
    fontWeight: 400,
  },
  dialogConfirmButton: {
    backgroundImage: "linear-gradient(to bottom, #5cb85c 0%, #449d44 100%)",
    backgroundRepeat: "repeat-x",
    border: "1px solid #345233",
    borderTop: "0px solid #345233",
    boxShadow: "0px 3px 3px #345233",
    maxWidth: 250,
  },
  dialogCancelButton: {
    background: "#c9302c",
    backgroundImage: "linear-gradient(to bottom, #d9534f 0%, #c9302c 100%)",
    border: "1px solid darkred",
    borderTop: "0px solid darkred",
    boxShadow: "0px 3px 3px darkred",
    maxWidth: 150,
  },
  dialogBlueButton: {
    background: '#006996',
    // backgroundImage: "linear-gradient(to bottom, #d9534f 0%, #c9302c 100%)",
    border: '1px solid #006996',
    borderTop: '0px solid #006996',
    boxShadow: '0px 3px 3px #006996',
    // maxWidth: 150,
  },
  dialogConfirmBlueButton: {
    backgroundImage: "linear-gradient(180deg,#5b9bcd 0%,#4678a3 100%)",
    maxWidth: 150,
  },
  dialogButtonsContainer: {
    flex: 1,
    alignContent: "center",
    justifyContent: "center",
    "@media screen and (max-width: 375px)": {
      "& .MuiGrid-item": {
        padding: "5px !important",
        marginTop: 15,
        marginBottom: 15,
      },
    },
  },
  //#endregion
  textCenter: {
    textAlign: "center !important",
  },
  marginBlock10: {
    marginBlock: 10,
  },
  marginBlock20: {
    marginBlock: 20,
  },
  MuiChipRoot: {
    // backgroundColor: "#FF3343 !important",
    background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
    marginRight: 5,
    "& span": {
      color: "#fff",
      fontWeight: 500,
    },
    "& .MuiChip-deleteIcon": {
      color: "#fff",
      fill: "currentColor",
    },
  },
  MuiChipBorder: {
    border: 'solid 2px #FF3343 !important',
    backgroundColor: theme.palette.type === 'dark' ? `${theme.custom.surface} !important` : '#FFF !important'
  },
  roundedBorder: {
    borderRadius: 50,
  },
  tooltipText: {
    ontWeight: 400,
    fontSize: 16,
    direction: isRTL ? 'rtl' : 'ltr',
    color: theme.custom.tooltipSurfaceText
  },
  autoCompleteTag: {
    '& .MuiAutocomplete-tag': {
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
      border: `solid 2px ${theme.palette.type === 'dark' ? theme.custom.accentOutline : '#F65026'}`,
      color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
      fontWeight: 'bold',
      '& .MuiChip-deleteIcon': {
        fill: theme.palette.type === 'dark' ? theme.custom.accentOutline : '#F65026'
      }
    }
  },
  noHoverBg: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  p5: {
    padding: 5
  },
  p15: {
    padding: 10
  },
  maxContent: {
    width: 'max-Content'
  },
  alignDir: {
    textAlign: isRTL ? "right" : "left"
  },
  '.MuiAccordion-root': {
    '&::before': {
      top: '-1px',
      left: 0,
      right: 0,
      height: 1,
      content: "",
      opacity: 1,
      position: 'absolute',
      transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      backgroundColor: 'rgba(0, 0, 0, 0.12)'
    }
  },
  customScroll: {
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      'boxShadow': 'inset 0 0 5px #e9e9e9',
      'borderRadius': '10px',
    },
  },
  comingSoonTab: {
    marginInlineStart: 10,
    padding: '2px 10px',
    borderRadius: 5,
    borderBottomRightRadius: 0,
    background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
  },

  areaManual: {
    border: theme.palette.type === 'dark' ? `2px dashed ${theme.custom.border}` : "2px dashed rgba(0,0,0,.2)",
    // height: "400px",
    backgroundColor: theme.palette.type === 'dark' ? `${theme.custom.surface} !important` : "white !important",
    "@media screen and (max-width: 768px)": {
      width: "auto",
    },
  },
  greenManual: {
    border: "2px dashed #4BB543",
    // height: "400px",
    backgroundColor: "#CCFFE5",
    "@media screen and (max-width: 768px)": {
      width: "auto",
    },
  },

  editorCont: {
    marginTop: 40,
    marginBottom: 50,
    // background: '#fff',
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    // '& .head': {
    //   background: '#F0F5FF',
    //   borderTopLeftRadius: 10,
    //   borderTopRightRadius: 10,
    // },
    // '& .mgmtTitle': {
    //   fontSize: 22,
    //   width: '100%'
    // },
    '& .containerBody': {
      paddingInline: 20,
      paddingTop: 20,
      // Shared migrated-screen surface (PR-3821-3827) — this wrapper is reused by
      // 14+ creation/editor screens (Newsletter, SMS, Automations, WhatsApp,
      // LandingPages, Notifications, Integrations, SiteTracking), so fixing it
      // here covers all of them at once instead of per-screen.
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
      border: theme.palette.type === 'dark' ? `2px solid ${theme.custom.border}` : "2px solid #F0F5FF",
      [safeTheme.breakpoints.down("xs")]: {
        paddingTop: 10,
        paddingInline: 10,
      },
      // Plain text (labels, helper text) inherits color via the cascade, so a
      // container-level color covers it — but MUI's own Input/Select components set
      // their OWN color explicitly via JSS (theme.palette.text.primary, frozen light
      // — see theme.js), which wins over inheritance. Both need a dark-mode override;
      // omitted entirely in light mode so this stays byte-identical to before.
      ...(theme.palette.type === 'dark' ? {
        color: theme.custom.textPrimary,
        '& .MuiInputBase-input, & .MuiSelect-select, & .MuiOutlinedInput-input, & .MuiInput-input': {
          color: theme.custom.textPrimary,
        },
        '& .MuiFormLabel-root, & .MuiInputLabel-root, & .MuiFormHelperText-root': {
          color: theme.custom.textSecondary,
        },
      } : {}),

      '& .stepHead': {
        fontSize: 20,
        display: 'flex',
        '& .stepNum': {
          padding: '6px 12px',
          fontWeight: 700,
          background: 'red',
          color: '#fff',
          // alignSelf: 'center'
        },
        '& .stepTitle': {
          // paddingInline: '6px',
          // alignSelf: 'center'
          // background: 'red',
          marginInlineStart: 5,
          margin: 'auto',
          paddingTop: 5,
          paddingBottom: 5
        },
        '& .stepDesc': {
          fontSize: 20,
          margin: 'auto',
          marginInline: 5,
          paddingTop: 5,
          paddingBottom: 5,
          "@media screen and (max-width: 768px)": {
            fontSize: 15,
          },
        }
      },
      '& .bodyBlock': {
        paddingInline: 10,
        [theme.breakpoints.down('xs')]: {
          paddingInline: 0
        },
      },
      '& .selectWrapper': {
        height: 'auto',
        '& .MuiSelect-root': {
          padding: '7px 0 11px 0px'
        },
        '& .bottomAlignedSelect': {
          '& .MuiSelect-root': {
            padding: '11px 0px 2px 0'
          },
          '& .MuiInputAdornment-root': {
            marginTop: 8
          }
        },
        '& .MuiTypography-body1': {
          marginLeft: isRTL ? 12 : 0
          // marginRight isRTL ? 0 : 12,
          // marginLeft: isRTL ? 12 : 0
        }

      },
      '& .textBoxWrapper': {
        // paddingTop: 30,
        '& .MuiTypography-body1': {
          color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#979797',
          wordBreak: 'break-all',
        },
        '& .MuiTextField-root': {
          paddingBottom: 8,
          paddingTop: 8,
          // maxWidth: 245,
          '&.fullWidth': {
            maxWidth: '100%'
          },
          '& input': {
            padding: 0
          }
        },
      }
    }
  },

  settingsContainer: {
    height: '100%',
    marginBottom: 68,
    background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    // marginTop: 30,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    '& .head': {
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      '& .mgmtTitle': {
        fontSize: 20
      }
    },
    '& .link': {
      fontSize: 15,
      color: '#FF0054',
      padding: '2px 0',
      // marginTop: 28,
      marginLeft: 0
    },
    '& .containerBody': {
      position: 'relative',
      paddingBottom: 48,
      // minHeight: 'calc(100vh - 10em)',
      borderBottomLeftRadius: 20,
      borderBottomRightRadius: 20,
      border: theme.palette.type === 'dark' ? `2px solid ${theme.custom.border}` : "2px solid #F0F5FF",
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
      paddingInline: 17.2,
      '& .settingsWrapper': {
        '& .mgmtTitle': {
          fontSize: 18,
          width: '100%'
        },
        '& .formContainer': {
          position: 'relative',
          paddingLeft: 15,
          paddingRight: 15,
          paddingBottom: 10,
          [safeTheme.breakpoints.down("xs")]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
          '& .form': {
            maxWidth: 900,
            background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
            zIndex: 100,
            position: 'relative',
          },
          '& .svg_data_analysis': {
            position: 'absolute',
            right: isRTL ? 'auto' : 85,
            left: isRTL ? 85 : 'auto',
            top: 49.17,
            transform: isRTL ? 'scaleX(1)' : 'scaleX(-1)'
          },
          '& .svg_app_settings': {
            position: 'absolute',
            top: 40,
            right: isRTL ? 'auto' : 90,
            left: isRTL ? 90 : 'auto',
            transform: isRTL ? 'scaleX(1)' : 'scaleX(-1)'
          },
          '& .subHeading': {
            marginTop: 39,
            color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
          },
          '& .MuiFormControl-root': {
            maxWidth: 245,
            '& .MuiSelect-root': {
              padding: 0,
              '&:focus': {
                background: 'none'
              },
              '& input': {
                padding: 0
              }
            },
            '& .subform': {
              marginTop: 22,
              '& .selectWrapper': {
                height: 'auto',
                '& .MuiTypography-body1': {
                  marginLeft: isRTL ? 12 : 0
                  // marginRight: isRTL ? 0 : 12,
                  // marginLeft: isRTL ? 12 : 0
                }
              },

            }
          },
          '& .MuiTypography-body1': {
            color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#979797',
          },
          '& .link': {
            fontSize: 15,
            color: '#FF0054',
            padding: '2px 0',
            marginTop: 28,
            marginLeft: 0
          }
        }
      },
      '& .textBoxWrapper': {
        paddingTop: 30,
        '& .MuiTypography-body1': {
          color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#979797',
        },
        '& .MuiTextField-root': {
          paddingBottom: 2,
          maxWidth: 245,
          '& input': {
            padding: 0
          }
        }
      }

      // display: 'grid',
      // padding: '0 17px 32.8px 17px'
    }
  },

  addCardForm: {
    maxWidth: 470,
    margin: 0,
    '& .textBoxWrapper': {
      maxWidth: '100%'
    },
    '& .MuiFormControl-root': {
      maxWidth: '100%',
      '& .MuiSelect-root': {
        maxHeight: 29,
        overflow: "hidden",
        padding: '3px 0 7px 0',

        '&:focus': {
          background: 'none'
        },
        '& input': {
          padding: 0
        }
      },
      '& .MuiSelect-icon': {
        display: 'none'
      },
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 0
    },
    '& .MuiInputAdornment-root': {
      color: '#ff104b',
      '& svg': {
        cursor: 'pointer',
        // '&:hover':{

        // },
        '& path': {
          fill: '#ff104b !important'
        }
      }
    }
  },

  areaCon: {
    width: "calc(100% - 20px)",
    outline: "none",
    border: "none",
    fontSize: "16px",
    fontFamily: "Sans-serif",
    resize: "none",
    height: 315,
    backgroundColor: theme.palette.type === 'dark' ? `${theme.custom.surface} !important` : "white !important",
    padding: "10px",
    "&::placeholder": {
      color: "rgb(170, 170, 170)",
      fontSize: "16px",
      fontFamily: "inherit",
    },
    "@media screen and (max-width: 965px)": {
      maxHeight: 275
    },
    "@media screen and (max-width: 768px)": {
      width: "90%",
    },
  },
  greenCon: {
    width: "calc(100% - 20px)",
    outline: "none",
    border: "none",
    fontFamily: "Sans-serif",
    resize: "none",
    height: 315,
    backgroundColor: "#CCFFE5",
    padding: "10px",
    "&::placeholder": {
      color: "rgb(170, 170, 170)",
      fontSize: "16px",
      fontFamily: "inherit",
    },
  },
  addManualDiv: {
    // padding: "8px !important",
    // backgroundColor: "#51AA51 !important",
    // color: "#fff !important",
    // marginInlineEnd: "6px !important",
    // borderRadius: "6px !important",
    cursor: "pointer !important",
    "@media screen and (max-width: 768px)": {
      fontSize: "10px !important",
    },
  },
  clearDiv: {
    padding: "8px !important",
    color: "#277BFF !important",
    marginInlineEnd: "6px !important",
    borderRadius: "6px !important",
    cursor: "pointer !important",
    border: "1px solid #277BFF !important",
    "@media screen and (max-width: 768px)": {
      fontSize: "10px !important",
    },
  },
  backBtn: {
    marginTop: "30px",
    boxShadow: "0 1px 2px #a5a2a2",
    padding: "12px",
    backgroundColor: "#4F87B5",
    width: "70px",
    color: "white",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
  },
  pulseDiv: {
    display: "flex",
    marginTop: "20px",
    alignItems: "center",
  },
  pulse: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 14,
    border: "1px solid #ff3343",
    padding: "8px",
    marginInlineEnd: "8px",
    borderRadius: "4px",
    cursor: "pointer",
    color: "#ff3343",
    '& svg': {
      marginInlineEnd: 5
    },
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "#ff3343",
    },
  },

  pulseDisable: {
    padding: 8,
    fontSize: 14,
    borderRadius: 4,
    display: "flex",
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : "#808080",
    marginInlineEnd: 8,
    alignItems: "center",
    pointerEvents: "none",
    cursor: "not-allowed",
    border: "1px solid  #808080",
    justifyContent: "space-between",
    '& svg': {
      marginInlineEnd: 5
    },
  },
  toggleDiv: {
    display: "flex",
    alignItems: "center",
    width: "100px",
  },
  inputDays: {
    padding: "10px",
    outline: "none",
    width: "70px",
    // marginInlineEnd: "5px",
    marginBottom: "8px",
    textAlign: "center",
    paddingRight: 0,
    paddingLeft: 0,
    borderRadius: 5,
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #bbb",
  },
  before: {
    display: 'flex',
    width: '72px',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomLeftRadius: isRTL ? null : '4px',
    borderBottomRightRadius: isRTL ? '4px' : null,
    borderTopLeftRadius: isRTL ? null : '4px',
    borderTopRightRadius: isRTL ? '4px' : null,
    border: '1px solid #f74f26',
    padding: '10px',
    marginBottom: '8px',
    color: '#f74f26',
    cursor: 'pointer',
  },
  disabledBefore: {
    display: "flex",
    width: "72px",
    alignItems: "center",
    justifyContent: "center",
    borderBottomLeftRadius: "4px",
    borderTopLeftRadius: "4px",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #D3D3D3",
    padding: "10px",
    marginBottom: "8px",
    color: "#D3D3D3",
    cursor: "pointer",
  },
  after: {
    display: 'flex',
    width: '72px',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomLeftRadius: isRTL ? '4px' : null,
    borderBottomRightRadius: isRTL ? null : '4px',
    borderTopLeftRadius: isRTL ? '4px' : null,
    borderTopRightRadius: isRTL ? null : '4px',
    // borderLeft: "none",
    border: '1px solid #f74f26',
    padding: '10px',
    marginBottom: '8px',
    color: '#f74f26',
    cursor: 'pointer',
  },
  disabledAfter: {
    display: "flex",
    width: "72px",
    alignItems: "center",
    justifyContent: "center",
    borderBottomRightRadius: "4px",
    borderTopRightRadius: "4px",
    borderLeft: "none",
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #D3D3D3",
    padding: "10px",
    marginBottom: "8px",
    color: "#D3D3D3",
    cursor: "pointer",
  },
  beforeActive: {
    display: 'flex',
    width: '72px',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomLeftRadius: isRTL ? null : '4px',
    borderBottomRightRadius: isRTL ? '4px' : null,
    borderTopLeftRadius: isRTL ? null : '4px',
    borderTopRightRadius: isRTL ? '4px' : null,
    border: '1px solid #FF3343',
    padding: '10px',
    marginBottom: '8px',
    backgroundColor: '#FF3343',
    color: '#ffffff',
    cursor: 'pointer',
  },
  afterActive: {
    display: 'flex',
    width: '72px',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomRightRadius: isRTL ? null : '4px',
    borderBottomLeftRadius: isRTL ? '4px' : null,
    borderTopRightRadius: isRTL ? null : '4px',
    borderTopLeftRadius: isRTL ? '4px' : null,
    borderLeft: 'none',
    border: '1px solid #f74f26',
    padding: '10px',
    marginBottom: '8px',
    backgroundColor: '#f74f26',
    color: '#ffffff',
    cursor: 'pointer',
  },
  // smsGrid: {
  //   padding: "40px 80px 15px 80px"
  // },
  msgDiv: {
    marginTop: 50,
    height: "400px",
    "@media screen and (max-width: 960px)": {
      marginTop: 0,
      height: "auto",
    },
    "@media screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  boxDiv: {
    width: "100%",
    "@media screen and (max-width: 768px)": {
      width: "100%",
      marginBottom: "10px",
    },
    "@media screen and (max-width: 960px)": {
      width: "100%",
      marginBottom: "10px",
    },
  },
  emoji: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    borderInlineEnd: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid black",
    paddingInlineEnd: "0",
    "@media screen and (max-width: 768px)": {
      flexDirection: "column",
      borderRight: "none",
    },
  },
  emojiHe: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    borderInlineEnd: "1px solid grey",
    paddingInlineStart: "8px",
    height: "100%",
    "@media screen and (max-width: 768px)": {
      flexDirection: "column",
      paddingInlineStart: 0,
      // borderRight: "1px solid black",
    },
  },
  pickerEmoji: {
    position: "relative",
    verticalAlign: "sub",
    height: "100%",
    zIndex: "99",
    display: "inline-block",
    alignItems: "center",
    justifyContent: "center",
    "@media screen and (max-width: 768px)": {
      marginTop: "4px",
    },
    //#region emoji
    "& .emoji-group": {
      "&::before": {
        direction: isRTL ? "rtl" : "ltr",
      },
    },
    "& .emoji-search": {
      direction: "ltr",
    },
    //#endregion
  },
  endButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
    "@media screen and (max-width: 768px)": {
      flexDirection: "column-reverse",
      // borderInlineStart: "1px solid black",
      borderInlineStart: 'none'
    }
  },
  radio: {
    display: "flex",
    flexDirection: "column",
    "@media screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  switchDiv: {
    display: "flex",
    marginInlineStart: 25,
    "@media screen and (max-width: 768px)": {
      width: "100%",
      marginInlineStart: "0px",
      // marginBottom:"30px"
    },
  },
  dialogTopBar: {
    paddingInline: 15,
    height: 50,
    display: 'flex',
    alignItems: "center",
    // justifyContent: "center",
    flexDirection: isRTL ? 'row-reverse !important' : 'row',
    color: "#fff",
    fontWeight: 600,
    background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
    '& .MuiStack-root': {
      display: 'flex',
      flexDirection: isRTL ? 'row-reverse' : 'row',
      // paddingInlineStart: 15,
      // paddingInlineEnd: 15,
    },
    '& svg': {
      fontSize: 30
    },
    '& .dialogTitle': {
      width: 'calc(100% - 65px)',
      direction: isRTL ? 'rtl' : 'ltr',
    }
  },
  textRight: {
    textAlign: "right",
  },
  textLeft: {
    textAlign: "left",
  },

  elipsis: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  scrollY: {
    overflowX: 'hidden',
    overflowY: 'scroll',

  },
  checkbox: {
    '&.MuiCheckbox-root': {
      color: '#FF3343',
      '&.Mui-checked': {
        color: 'FF3343',
      },
    },
  },
  switchButton: {
    background: '#e4e4e4',
    padding: '2px 10px 3px 10px',
    boxShadow: 'inset 0px 0px 5px #898888',
    fontWeight: 500,
    cursor: 'pointer'
  },
  switchButtonActive: {
    background: '#a9d9a9',
    padding: '2px 10px 3px 10px',
    boxShadow: '0px 0px 5px #898888',
    fontWeight: 500,
    cursor: 'pointer'
  },
  toggleSwitch: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#339933',
      '&:hover': {
        backgroundColor: 'transparent'
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#339933',
    },
  },

  textField: {
    '&.MuiTextField-root': {
      width: '100%',
      borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #D6D1E6',
      paddingLeft: 5,
      '&:hover': {
        borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.textSecondary}` : '1px solid #000',
        '& .MuiInputAdornment-root': {
          '& svg': {
            '& path': {
              fill: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
            }
          }
        }
      },
      '& input': {
        padding: '3px 0 7px 0',
        minHeight: 25,
      },
      '& fieldset': {
        border: 'none',
      },
      '& .MuiInputAdornment-root': {
        '& svg': {
          '& path': {
            fill: '#B3B3B3'
          }
        }
      },
      '& label + .MuiInput-formControl': {
        marginTop: '10px',
      },

    },
    // [theme.breakpoints.down('xs')]: {
    //   width: 'auto !important'
    // },
  },

  textFieldError: {
    border: 'none !important',
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
      marginRight: 0,
      width: '100%',
      color: theme.palette.type === 'dark' ? theme.custom.statusError : 'red'
    },
    "& .MuiInputBase-root": {
      "& input": {
        borderBottom: '2px solid red'
      },
    }
  },
  ltr: {
    direction: 'ltr'
  },
  rtl: {
    direction: 'rtl'
  },
  selectPlaceholderInput: {
    height: '90%',
    opacity: 1,
    border: 'none',
    boxShadow: 'none',
    background: 'none',
    width: '95%',
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: '0.9rem',
    position: 'absolute',
    pointerEvents: 'none',
    '&::placeholder': {
      color: '#bfbfbf'
    }
  },

  selectInputFormControl: {
    '&.MuiFormControl-root': {
      marginInline: 3,
      borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #d6d1e6",
      "&:hover": {
        borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : "1px solid #000"
      },
      '& label': {
        marginInline: 5
      },
      '& .MuiInput-root': {
        direction: isRTL ? 'rtl' : 'ltr',
      },
      '& .MuiSelect-root': {
        minHeight: 25,
        maxHeight: 29,
        overflow: "hidden",
        padding: '3px 0 7px 0',

        '&:focus': {
          background: 'none'
        },
        '& input': {
          padding: 0
        }
      },
      '& .MuiSelect-icon': {
        display: 'none'
      },
      '& .outerborder': {
        // border: '1px solid #c4c4c4',
        borderRadius: 5,
        '& .MuiSelect-select': {
          border: 'none !important'
        },
      },
      '& .MuiSelect-select': {
        minWidth: '100px !important',
        width: '100%',
        maxWidth: '100%',
        borderRadius: 4,
        paddingInlineStart: 15,
        paddingInlineEnd: 40,
        // paddingLeft: 0,
        // paddingRight: 0,
        minHeight: 25,
        display: 'block',
        alignItems: 'center',
        // '&:focus': {
        //   backgroundColor: '#fff !important'
        // }
      },
      '& svg': {
        color: '#ff3343',
        left: isRTL ? 10 : 'auto',
        right: isRTL ? 'auto' : 10,
      }
    }
  },
  dropdownIconComponent: {
    position: 'absolute',
    pointerEvents: 'none'
  },
  iconTab: {
    '& .MuiTab-wrapper': {
      display: 'inline-block',
    },
    '& img': {
      verticalAlign: 'bottom',
      marginBottom: '0px !important',
      paddingRight: isRTL ? '0px' : '15px',
      paddingLeft: !isRTL ? '0px' : '15px',
      height: '30px'
    }
  },
  InputMaskTextField: {
    padding: 10,
    borderBottom: theme.palette.type === 'dark' ? `solid 1px ${theme.custom.border}` : 'solid 1px #c4c4c4',
    fontSize: 14,
    width: 390,
    letterSpacing: 1
  },
  whatsapp: {
    '& .MuiSelect-select': {
      minHeight: '35px !important',
    },
    '& .MuiSelect-icon': {
      top: 15
    }
  },
  dialogZindex: {
    zIndex: '1000 !important'
  },
  testSendDialog: {
    width: '100%',
    maxWidth: 390
  },
  containerFullHeight: {
    minHeight: 'calc(100vh - 140px)',
    height: 'calc(100vh - 140px)',
    // Wraps the BEE iframe mount points (BeeEditor.tsx, BeeEditorPopup.tsx,
    // CampaignEditorBee.js). BEE itself goes dark via customCss (Editors/helper/beeDarkTheme.ts),
    // so the mount point matches it instead of flashing white while BEE loads.
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : undefined,
  },
  pb15: {
    paddingBottom: 15
  },
  pb25: {
    paddingBottom: 25
  },
  pbt9: {
    paddingTop: 9,
    paddingBottom: 9
  },
  pbt10: {
    paddingTop: 10,
    paddingBottom: 10
  },
  pbt15: {
    paddingTop: 15,
    paddingBottom: 15
  },
  buttonMinWidth: {
    minWidth: 167
  },
  noShadowAccordion: {
    boxShadow: 'none',
    '&.MuiAccordion-root': {
      '&:before': {
        height: 0,
      },
    },
  },
  filterHeight: {
    height: '65vh',
  },
  root: {
    '.Mui-expanded': {
      margin: '0 !important',
    },
  },
  flexColumnCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textRed: {
    color: theme.palette.type === 'dark' ? theme.custom.statusError : '#c9302c'
  },
  commingSoon:
  {
    backgroundColor: "#dc3545",
    padding: 5,
    fontSize: 11,
    color: "#fff",
    borderRadius: 5,
    fontWeight: 400,
    marginInlineStart: "3px",
    marginBottom: '0 !important'
  },
  flexCenterOfCenter: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  passwordDialog: {
    maxWidth: windowSize !== 'xs' ? '25vw' : null
  },
  ribbonContainer: {
    position: 'relative',
    '& .wrap': {
      width: 'inherit',
      height: '58px',
      position: 'absolute',
      top: '-2px',
      left: '1.5px',
      overflow: 'hidden',
      '& .ribbon': {
        width: '45px',
        height: '10px',
        lineHeight: '10px',
        position: 'absolute',
        top: '8px',
        right: isRTL ? 'auto' : '-10px',
        left: isRTL ? '-10px' : 'auto',
        zIndex: '2',
        overflow: 'hidden',
        transform: isRTL ? 'rotate(-45deg)' : 'rotate(45deg)',
        '-webkit-transform': isRTL ? 'rotate(-45deg)' : 'rotate(45deg)',
        boxShadow: '0px 0px 2px 1px #b7b7b7,  0px 21px 5px -18px rgba(0,0,0,0.6)',
        background: '#ff0000',
        textAlign: 'center',
        fontSize: '0.5rem',
        color: "#fff"
      }
    }
  },
  disabledButPointer: {
    opacity: ".65",
    pointerEvents: "unset !important",
    cursor: "not-allowed !important",
  },
  disableChildButtons: {
    '& button': {
      opacity: ".65",
      pointerEvents: "none !important",
      cursor: "not-allowed !important",
    }
  },
  cursorPointer: {
    cursor: 'pointer'
  },
  flexGrow1: {
    flexGrow: 1
  },
  shopifySettingTextBox: {
    '& input': {
      minWidth: '400px',
      maxWidth: '400px',
      paddingLeft: 5,
      borderBottom: theme.palette.type === 'dark' ? `solid 1px ${theme.custom.border}` : 'solid 1px #c4c4c4',
      paddingTop: 10,
      paddingBottom: 10,
    },
    '& .selectBox': {
      marginLeft: 30,
      border: "1px solid #818181",
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : "white",
      padding: "10px",
      borderRadius: "4px",
      width: 400,
      outline: "none",
      display: 'block'
    },
  },
  shopifySettingMultiSelect: {
    paddingLeft: '30px',
    '& #multiple-checkbox': {
      width: 330,
    },
    '& .group-dropdown': {
      width: 400,
    },
    '& .MuiSelect-icon': {
      position: 'initial',
      paddingRight: '10px'
    },
    textFieldWithTemplate: {
      display: 'flex',
      marginTop: 5,
      border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #ccc',
      borderRadius: 4,
      height: 28,
      padding: 5,
      justifyContent: 'center'
    },
    justifyContentEnd: {
      justifyContent: 'flex-end'
    },
    errorIcon: {
      position: 'absolute',
      top: 0,
      left: isRTL ? 0 : 'auto',
      right: isRTL ? 'auto' : 0,
      zIndex: 100,
      fontSize: 25,
      fill: 'white',
      backgroundColor: 'red',
      borderRadius: 25
    }
  },
  alignSelfCenter: {
    alignSelf: 'center'
  },
  alignSelfTop: {
    alignSelf: 'flex-start'
  },
  smallActionIcons: {
    '& button': {
      minWidth: 45,
    },
    '& svg': {
      padding: 3
    },
    '& p': {
      fontSize: '12px !important'
    },
    '& .MuiBox-root': {
      '& div': {
        height: '20px !important',
        width: '20px !important'
      }
    }
  },
  callToAction: {
    minWidth: '50vw',
    "& .MuiDialog-paperWidthSm": {
      minWidth: '80vw',
      maxWidth: '80vw',
    },
    "& .MuiDialog-paperScrollPaper": {
      maxHeight: '100%'
    },
    '& .MuiDialogActions-root': {
      marginTop: 20
    },
    '& .keep-track': {
      paddingTop: 5,
    },
    '& .keep-track-desc': {
      color: '#aaa'
    }
  },
  paddingInline5: {
    paddingInline: 5
  },
  paddingInline10: {
    paddingInline: 10
  },
  paddingInline25: {
    paddingInline: 25
  },
  paddingInline30: {
    paddingInline: 30
  },
  desktop: {
    boxSizing: 'border-box',
    '& .ep_container': {
      width: 'calc(50vw)',
      margin: '0px auto',
      position: 'relative',
      transform: 'scale(0.7)',
      '& .ep_base': {
        width: 90,
        height: 50,
        bottom: -70,
        left: '45%',
        background: '#e8ebf0',
        position: 'absolute',
        '&:before': {
          content: "",
          position: 'absolute',
          top: 0,
          borderLeft: '13px solid transparent',
          borderRight: '0px solid transparent',
          borderBottom: '50px solid #e8ebf0',
          left: -13,
        },
        '&:after': {
          content: "",
          position: 'absolute',
          top: 0,
          borderRight: '13px solid transparent',
          borderLeft: '0px solid transparent',
          borderBottom: '50px solid #e8ebf0',
          right: -13,
        },
        '& .ep_div': {
          position: 'absolute',
        }
      },
      '& .ep_content': {
        // HTML Content
        // width: '-webkit-fill-available',
        // height: 'calc(43vh)',

        // iFrame
        width: '100%',
        height: '100%',

        overflow: 'auto',
        '&:before': {
          content: "",
          position: 'absolute',
          right: -90,
          width: 200,
          height: 300,
          transform: 'rotate(45deg)',
          background: 'linear-gradient(to bottom, rgba(255,255,255,0.1) 0%,rgba(255,255,255,0) 100%)',
          zIndex: 5,
        }
      },
      '& .ep_screen': {
        width: 'auto',
        height: 'calc(50vh)',
        position: 'relative',
        background: '#fff',
        border: '20px solid #474e5d',
        borderRadius: 10,
        '&:after': {
          width: 8,
          height: 8,
          borderRadius: 8,
          bottom: -10,
          margin: '0 0 -4px -4px',
          background: '#e8ebf0'
        }
      },
      '& .ep_monitor': {
        '& .ep_div': {
          position: 'absolute'
        },
        '&:before': {
          content: "",
          position: 'absolute',
          left: '50%',
          top: -10,
          margin: '-3px 0 0 -3px',
          width: 6,
          height: 6,
          borderRadius: 6,
          background: '#a5adbd'
        },
        '&:after': {
          content: "",
          position: 'absolute',
          left: '50%',
        }
      },
      '& .ep_foot': {
        background: '#e8ebf0',
        zIndex: 1,
      },
      '& .ep_top': {
        width: 116,
        height: 5,
        bottom: -5,
        left: '50%',
        marginLeft: -58,
        '&:before': {
          content: "",
          position: 'absolute',
          top: 0,
          borderLeft: '16px solid transparent',
          borderRight: '0px solid transparent',
          borderBottom: '5px solid #e8ebf0',
          left: -16,
        },
        '&:after': {
          content: "",
          position: 'absolute',
          top: 0,
          borderRight: '16px solid transparent',
          borderLeft: '0px solid transparent',
          borderBottom: '5px solid #e8ebf0',
          right: -16,
        }
      },
      '& .ep_bottom': {
        width: 150,
        height: 5,
        bottom: -10,
        left: '50%',
        marginLeft: -75,
        zIndex: 999,
      },
      '& .ep_shadow': {
        position: 'absolute',
        width: 350,
        height: 15,
        left: '50%',
        marginLeft: -175,
        zIndex: -1,
        bottom: -20,
        background: 'radial-gradient(ellipse at center, rgb(150 150 150) 0%,rgb(255 255 255) 53%,rgb(255 255 255) 55%,rgba(46,204,113,0) 55%,rgba(46,204,113,0) 100%)',
      }
    },
  },
  mobilePreview: {
    position: 'relative',
    width: 360,
    height: 640,
    margin: 'auto',
    border: '16px black solid',
    borderTopWidth: 60,
    borderBottomWidth: 60,
    borderRadius: 36,
    '&:before': {
      content: '',
      display: 'block',
      width: 60,
      height: 5,
      position: 'absolute',
      top: -30,
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: '#333',
      borderRadius: 10,
    },
    '&:after': {
      content: '',
      display: 'block',
      width: 35,
      height: 35,
      position: 'absolute',
      left: '50%',
      bottom: -65,
      transform: 'translate(-50%, -50%)',
      background: '#333',
      borderRadius: '50%'
    },
    '& .content': {
      width: '100%',
      height: '100%',
      background: 'white',
      overflow: 'auto'
    }
  },
  whiteIcon: {
    fontSize: 20,
    padding: 5,
    color: '#fff',
    fill: '#fff',
    '& svg, & path': {
      stroke: '#fff',
      color: '#fff',
      fill: '#transparent'
    }
  },
  marginInlineStart5: {
    marginInlineStart: 5
  },
  marginInlineEnd5: {
    marginInlineEnd: 5
  },
  marginInlineStart10: {
    marginInlineStart: 10
  },
  marginInlineEnd10: {
    marginInlineEnd: 10
  },
  marginInlineStart15: {
    marginInlineStart: 15
  },
  marginInlineEnd15: {
    marginInlineEnd: 15
  },
  verticalAlignTop: {
    verticalAlign: 'top'
  },
  verticalAlignMiddle: {
    verticalAlign: 'middle'
  },
  messageButtons: {
    display: 'contents'
  },
  underline: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  alignItemsStart: {
    alignItems: "start",
  },
  fullFlexColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& .flexEnd': {
      alignSelf: 'flex-end'
    }
  },
  centeredLink: {
    display: 'flex',
    alignSelf: 'center',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  flexEnd: {
    justifyContent: 'flex-end'
  },
  textFieldWithTemplate: {
    display: 'flex',
    marginTop: 5,
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #ccc',
    borderRadius: 4,
    height: 28,
    padding: 5,
    justifyContent: 'center'
  },
  errorIcon: {
    position: 'absolute',
    top: 0,
    left: isRTL ? 0 : 'auto',
    right: isRTL ? 'auto' : 0,
    zIndex: 100,
    fontSize: 25,
    fill: 'white',
    backgroundColor: 'red',
    borderRadius: 25
  },
  tooltipIcon: {
    display: 'flex',
    // tooltipSurface (#333333) differs from this class's original pure-black literal
    // — branch so light mode stays byte-identical to the pre-migration value.
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.tooltipSurface : '#000',
    color: theme.custom.tooltipSurfaceText,
    fontSize: 13,
    borderRadius: 25,
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center'
  },
  flexStart: {
    justifyContent: "flex-start"
  },
  errorBg: {
    // Light-pink warning tint reads fine on a light card but disappears (and makes
    // the dark-mode-white select text unreadable) on the dark card — swap to a
    // dark-tinted version of the same warning red instead of the raw literal.
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 23, 68, 0.16)' : '#fde2e2'
  },
  fromEmailSelect: {
    '& :focus': {
      backgroundColor: 'transparent !important'
    }
  },
  reipientReportCampaignName: {
    display: 'grid !important',
    wordBreak: 'break-all',
    minHeight: 50,
    margin: 'auto',
  },
  selectOption: {
    width: '100%',
    display: 'flex',
    height: '30px !important',
    alignItems: 'center !important',
    paddingInline: '15px !important',
    paddingBlock: '10px !important'
  },
  productCatalogDialog: {
    '& .MuiPaper-root': {
      maxWidth: '70% !important',
      width: '70% !important',
      padding: '10px !important'
    }
  },
  selectField: {
    borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #D6D1E6',
    height: 46
  },
  pageContainer: {
    marginLeft: '7rem',
    marginRight: '7rem',
  },
  fieldOfInterestButton: {
    borderRadius: 10,
    paddingInline: 20,
    textTransform: 'none',
    '& .MuiButton-startIcon': {
      marginRight: 0,
      marginLeft: 0,
      paddingInline: 5,
    },
    [theme.breakpoints.down('xs')]: {
      display: 'inline-flex',
      marginBottom: 0,
    },
  },
  SignUpCountryDropdown: {
    '& .MuiSelect-select': {
      justifyContent: 'flex-start'
    },
    '& .MuiInput-root': {
      direction: 'ltr !important',
    },
    '@media screen and (max-width: 960px)': {
      '& .MuiAutocomplete-input': {
        textAlign: 'center',
        marginLeft: '2rem',
      },
    },
  },
  SignUpLanguageDropdown: {
    width: 180,
    borderRadius: 5,
    '& .MuiSelect-select': {
      padding: '5px 10px !important',
      display: 'flex !important',
      justifyContent: 'flex-end'
    },
    '& img': {
      height: 20,
    },
    '& .cname': {
      paddingInline: 10,
    }
  },
  gradientBackground: {
    background: 'linear-gradient(90deg, #FF0076 1.31%, #FF0054 33.07%, #FF4D2A 134.74%)',
  },
  passwordVisibilityToggle: {
    top: 0,
    right: isRTL ? 'initial' : 0,
    left: isRTL ? 0 : 'initial'
  },
  autoComplete: {
    '& .MuiAutocomplete-endAdornment': {
      right: isRTL ? 'unset' : '0px',
      left: isRTL ? '0px' : 'unset',
    },
    '& .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiAutocomplete-inputRoot.MuiInputBase-fullWidth.MuiInput-fullWidth.MuiInputBase-formControl.MuiInput-formControl.MuiInputBase-adornedEnd':
    {
      paddingRight: isRTL ? '0px !important' : '0px',
      paddingInlineEnd: 40
    },
  },
  highlightExpandedRow: {
    backgroundColor: theme.palette.type === 'dark' ? `${theme.custom.surfaceElevated} !important` : '#dbdbdb !important',
    borderLeft: theme.palette.type === 'dark' ? `solid 2px ${theme.custom.border}` : 'solid 2px #797979',
    borderRight: theme.palette.type === 'dark' ? `solid 2px ${theme.custom.border}` : 'solid 2px #797979',
    '&.last': {
      borderBottom: theme.palette.type === 'dark' ? `solid 2px ${theme.custom.border} !important` : 'solid 2px #797979 !important',
    },
    '&.first': {
      borderTop: theme.palette.type === 'dark' ? `solid 2px ${theme.custom.border} !important` : 'solid 2px #797979 !important',
    },
  },
  renderHtml: {
    '& label': {
      display: 'block !important',
      '& select': {
        backgroundPosition: isRTL ? 'left center' : 'right-center'
      }
    }
  },
  flexContainerGap25: {
    gap: 25,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  mInline5: {
    marginInline: 5
  },
  mInline15: {
    marginInline: 15
  },
  left10: {
    left: 10,
    right: 'auto'
  },
  right10: {
    right: 10,
    left: 'auto'
  },
  left15: {
    left: 15,
    right: 'auto'
  },
  right15: {
    right: 15,
    left: 'auto'
  },
  accordion: {
    '& .MuiAccordionSummary-root': {
      margin: '20px 0 0 0',
      padding: 0,
      width: '100%'
    },
    '& .MuiAccordionSummary-content': {
      width: '100%',
      margin: '0 !important',
      padding: 0,
    }
  },
  btnActive: {
    color: "#fff",
    background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)'
  },
  MuiAccordionroot: {
    "&:before": {
      backgroundColor: 'transparent'
    },
    // MuiAccordion is a Paper under the hood and never set its own background here,
    // so it fell through to MUI's frozen-light theme.palette.background.paper (same
    // gotcha as BaseDialog). Used across 13 files (Recipient Search sections, etc.).
    ...(theme.palette.type === 'dark' ? {
      backgroundColor: theme.custom.surface,
      color: theme.custom.textPrimary,
      '& .MuiInputBase-input, & .MuiSelect-select, & .MuiOutlinedInput-input, & .MuiInput-input': {
        color: theme.custom.textPrimary,
      },
      '& .MuiFormLabel-root, & .MuiInputLabel-root, & .MuiFormHelperText-root': {
        color: theme.custom.textSecondary,
      },
    } : {}),
  },
  rocketImage: {
    width: '80%',
  },
  celebrationImage: {
    height: '200px',
  },
  payPerRecipientPlanDetail: {
    border: "solid 1px grey",
    borderRadius: 10,
    '& .MuiGrid-item': {
      "&:first-child": {
        borderRight: !isRTL ? "solid 1px grey" : '',
        borderLeft: isRTL ? "solid 1px grey" : '',
      }
    }
  },
  payPerRecipientDialog: {
    maxWidth: '100%',
    iframe: {
      border: 'none'
    },
    '& .MuiDialog-paper': {
      minWidth: '80vw',
      maxWidth: '80vw'
    },
    '& .payPerRecipientChild': {
      // minHeight: '70vh',
      maxHeight: '70vh',
      overflowX: 'hidden'
    }
  },
  customSlider: {
    height: 12,
    padding: '20px 0',
    '& .MuiSlider-rail': {
      height: 12,
      borderRadius: 6,
      // backgroundColor: '#eee',
    },
    '& .MuiSlider-track': {
      height: 12,
      borderRadius: 6,
      backgroundColor: '#f73378',
    },
    '& .MuiSlider-thumb': {
      height: 32,
      width: 32,
      backgroundColor: '#fff',
      border: '2px solid #f73378',
      boxShadow: '0 0 10px #f73378',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:before': {
        // content: '"<<"',
        display: 'block',
        color: '#f73378',
        fontWeight: 'bold',
      },
      '&:hover, &.Mui-focusVisible': {
        boxShadow: '0 0 15px #f73378',
      },
    },
  },
  maxWidthMinContent: {
    maxWidth: 'min-content !important',
    "@media screen and (max-width: 540px)": {
      maxWidth: '100% !important'
    },
  },
  connectedDot: {
    '& .MuiBadge-dot': {
      left: isRTL ? 'auto' : -10,
      right: isRTL ? -10 : 'auto',
      top: 10,
      background: '#23ff23'
    }
  },
  loginForm: {
    border: '1px solid #FF4D2A',
    borderRadius: 15,
    boxShadow: '0px 5px 5px rgba(0, 0, 0, .5)'
  },
  logref: {
    background: 'linear-gradient(90deg, #FF0076 1.31%, #FF0054 33.07%, #FF4D2A 134.74%)',
    height: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopRightRadius: 14,
    borderTopLeftRadius: 14
  },
  stickBottom: {
    top: 'auto',
    bottom: 0,
    height: 70,
    background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#F0F5FF',
    width: '100%',
    right: 0,
    left: 0,
    alignItems: 'center',
    justifyContent: 'flex-end',
    borderTop: '0.5px solid #FF3343'
  },
  automationTemplate: {
    border: theme.palette.type === 'dark' ? `solid 1.5px ${theme.custom.border}` : 'solid 1.5px #fefefe',
    borderRadius: '5px',
    boxShadow: '0px 0px 10px #898888',
    padding: '15px',
    height: '110px',
    transition: 'all 0.5s ease',
    overflowY: 'hidden',
    "&:hover, &.active": {
      background: theme.palette.type === 'dark' ? 'rgba(255, 23, 68, 0.08)' : '#fff8f8',
      boxShadow: '0px 0px 10px #ff3343',
      borderColor: '#ff3343',
      transform: 'scale(1.03)',
    },
    "& .description": {
      height: '50px'
    }
  },
  overflowHidden: {
    overflow: 'hidden'
  },
  signupContainer: {
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    paddingBottom: '50px',
    background: 'linear-gradient(0deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
    overflowX: 'hidden',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
    position: 'relative',
    "@media (max-width: 768px)": {
      background: 'linear-gradient(0deg, #FF4D2A 0%, #FF0054 76.2%, #FF0076 100%)'
    },
    '& h1': {
      color: '#beff00',
      fontWeight: 900,
      marginBottom: '.75rem',
      fontSize: '2.75rem',
      "@media screen and (min-width: 1280px)": {
        fontSize: '3.5rem',
        lineHeight: '6rem',
      },
      "@media screen and (min-width: 1621px)": {
        fontSize: '4.5rem',
      },
      "@media screen and (min-width: 2480px)": {
        fontSize: '6rem',
      },
    },
    '& *': {
      fontSize: 'x-large',
      "@media screen and (max-width: 768px)": {
        fontSize: 'large',
      }
    },
    '& .signUpContainer': {
      marginTop: '5%',
      position: 'relative',
      '& .widgetContainer': {
        position: 'relative',
        background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
        margin: 'auto',
        height: '50%',
        borderRadius: '50px',
        padding: '20px 50px',
        boxShadow: '0 10px 30px -6px black',
        fontSize: '2rem',
        zIndex: 10,
        "@media screen and (max-width: 1440px)": {
          padding: '20px 40px',
        },
        "@media screen and (max-width: 1200px)": {
          padding: '20px 35px',
        },
        "&.remove-my-data": {
          width: '35%',
          padding: '20px',
          paddingBottom: '2rem',
          "& input::placeholder": {
            fontSize: "20px",
          },
        },
        "@media screen and (max-width: 768px)": {
          width: '85%',
          padding: '15px',
        },
        '& .previous, & .next': {
          background: '#beff00',
          border: 'solid 5px #fff',
          boxShadow: '0px 0px 5px 0px #000',
          bottom: '30px',
          height: '80px',
          width: '80px',
          position: 'absolute',
          padding: '0px',
          fontSize: '5rem',
          color: 'black',
          "@media screen and (max-width: 1440px)": {
            height: '70px',
            width: '70px',
            fontSize: '4.5rem',
          },
          "@media screen and (max-width: 1200px)": {
            height: '65px',
            width: '65px',
            fontSize: '4rem',
          },
        },
        '& .previous': {
          left: '-40px',
          "@media screen and (max-width: 1440px)": {
            left: '-35px',
          },
          "@media screen and (max-width: 1200px)": {
            left: '-32px',
          },
        },
        '& .next': {
          right: '-40px',
          "@media screen and (max-width: 1440px)": {
            right: '-35px',
          },
          "@media screen and (max-width: 1200px)": {
            right: '-32px',
          },
        },
      },
    },
    '& .down-arrow-container': {
      display: 'none',
      zIndex: 1,
      pointerEvents: 'none',
      position: 'relative',
      "@media screen and (min-width: 960px)": {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'flex-start',
      },
      '& .down-arrow-image': {
        width: 'clamp(90px, 8vw, 120px)',
        height: 'auto',
        position: 'absolute',
        right: 'clamp(0.5rem, 1vw, 1.5rem)',
        top: 'clamp(-18rem, -19vw, -22rem)',
      },
    },
    '& .mascot-container': {
      display: 'none',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      zIndex: 1,
      pointerEvents: 'none',
      position: 'relative',
      marginTop: '10rem',
      "@media screen and (min-width: 2100px)": {
        marginTop: '14rem',
      },
      "@media screen and (min-width: 960px)": {
        display: 'flex',
      },
      '& .mascot-image': {
        width: 'clamp(240px, 20vw, 320px)',
        height: 'auto',
        marginLeft: 'clamp(-4.5rem, -5vw, -6rem)',
      },
      '& .arrow-image': {
        width: 'clamp(90px, 7.5vw, 120px)',
        height: 'auto',
        marginTop: 'clamp(5rem, 5vw, 6rem)',
      },
      '& .time-text': {
        color: '#fff',
        fontSize: 'clamp(1.1rem, 1.3vw, 1.5rem)',
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.2,
        marginTop: '1rem',
        width: '115px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        direction: isRTL ? 'rtl' : 'ltr',
        marginLeft: 'clamp(-105px, -7.5vw, -85px)',
        "@media screen and (min-width: 960px) and (max-width: 1023px)": {
          marginLeft: 'clamp(-105px, -7.5vw, -95px)',
        },
        "@media screen and (min-width: 960px) and (max-width: 1075px)": {
          marginTop: '0rem',
        },
        "@media screen and (min-width: 1157px) and (max-width: 1490px)": {
          width: '100px',
          wordBreak: 'break-word',
        },
        "@media screen and (min-width: 960px) and (max-width: 1157px)": {
          wordBreak: 'normal',
          width: '110px',
        },
      },
    },
    '& .mobile-header-container': {
      '& h1': {
        margin: 0,
        fontSize: '2rem',
      },
      '& .MuiMobileStepper-root': {
         margin: '8px auto',
         padding: 5,
      },
      '& .mobile-down-arrow': {
        position: 'absolute',
        zIndex: 999,
        marginLeft: '15vw',
        marginTop: '-2.75rem',
        height: 70,
      },
      '& .mobile-mascot': {
        position: 'absolute',
        zIndex: 998,
        right: isRTL ? '1rem' : 'auto',
        bottom: 0,
        height: 155,
        transform: isRTL ? 'none' : 'scaleX(-1)',
      },
    },
    '& .stepper': {
      width: 'fit-content',
      margin: '16px auto',
      background: 'transparent',
      border: '1.25px solid #beff00',
    },
    '& .MuiMobileStepper-dotActive': {
      backgroundColor: '#beff00 !important',
    },
    '& .MuiMobileStepper-dot': {
      backgroundColor: '#fff',
    }
  },
  signUpFieldOfInterestButton: {
    borderRadius: 50,
    borderColor: theme.palette.type === 'dark' ? theme.custom.border : '#000',
    transition: 'background 0.2s ease',
    "@media screen and (max-width: 768px)": {
      width: '100%',
      display: 'flex'
    },
    '&.selected': {
      background: '#beff00 !important',
      color: '#000',
      '& svg': {
        color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
        fill: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
      }
    },
    '@media (hover: hover)': {
      '&:hover:not(.selected)': {
        background: '#beff00',
        color: '#000',
        '& svg': {
          color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
          fill: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
        },
      },
    },
    '@media (hover: none)': {
      '&:active:not(.selected)': {
        background: '#beff00',
        color: '#000',
        '& svg': {
          color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
          fill: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
        },
      },
      '&:hover:not(.selected)': {
        background: 'transparent',
        color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
        '& svg': {
          color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
          fill: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
        },
      },
    },
  },
  agentNameContainer: {
    backgroundColor: '#5EBD6A',
    color: '#fff',
    paddingInline: 5,
    paddingBlock: 2,
    fontSize: '12px',
    borderRadius: '4px',
    whiteSpace: 'nowrap'
  },
  removeMyDataButton: {
    fontSize: '1.2rem',
    borderRadius: 5,
    width: '70%',
    '& *': {
      fontSize: '1.2rem',
    }
  },
  reCAPTCHA: {
    "& div:first-child": {
      margin: 'auto'
    }
  },
  polishSubscribeGreyBox: {
    background: grey[100],
    borderRadius: 5,
  },
  tierPlansDialog: {
    '& .MuiPaper-root': {
      maxWidth: '100% !important',
    }
  },
  tierPlansCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '12px 16px',
    textAlign: 'center',
    boxShadow: '0 4px 30px rgba(0,0,0,.08)',
    transition: 'transform .3s ease, box-shadow .3s ease, border-color .3s ease',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
    '&:hover': {
      transform: 'scale(1.02)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    }
  },
  tierPlansFeatureText: {
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#1a202c',
    marginTop: 2,
    marginBottom: 2,
    '& span': {
      fontWeight: '600',
      fontFamily: isRTL ? 'Heebo' : 'inherit',
    },
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansPopularCard: {
    border: '2px solid #ff4d2a',
    position: 'relative',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansPopularBadge: {
    position: 'absolute',
    top: '-12px',
    left: '35%',
    transform: 'translateX(-15%)',
    background: 'linear-gradient(-45deg, #ff0076, #ff4d2a)',
    color: 'white',
    padding: '6px',
    width: '50%',
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    lineHeight: '1.2',
    textAlign: 'center',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansCardContent: {
    textAlign: 'center',
    padding: '8px 0 !important',
    paddingBottom: '8px !important',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansConstSmallText: {
    fontSize: '0.9rem',
    color: '#718096',
    textAlign: 'center',
    lineHeight: '1.4',
    marginTop: '75%',
    fontWeight: '500',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansTitle: {
    fontWeight: '800',
    fontSize: '1.05rem',
    letterSpacing: '.5px',
    textTransform: 'uppercase',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#1a202c',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansDescription: {
    color: '#718096',
    // marginBottom: '16px',
    padding: '0px 12px',
    fontWeight: 600,
    fontSize: '0.85rem',
    lineHeight: 1.4,
    minHeight: '2.4em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansPriceContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    // marginBottom: '8px',
    minHeight: '48px',
    fontWeight: 800,
    fontSize: '1.4rem',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#1a202c',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansPrice: {
    fontSize: '2.5rem',
    fontWeight: 800,
    fontSize: '1.4rem',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#1a202c',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
    '& span': {
      fontSize: '2.5rem',
      fontWeight: 800,
      fontSize: '1.4rem',
      color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#1a202c',
      fontFamily: isRTL ? 'Heebo' : 'inherit',
    }
  },
  tierPlansPriceDescription: {
    fontSize: '1rem',
    marginLeft: '4px',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansSubtext: {
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#6c757d',
    marginBottom: '16px',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansRecipientLimit: {
    marginBottom: '16px',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansButton: {
    marginTop: 'auto',
    borderRadius: '12px',
    padding: '5px 12px',
    fontWeight: 'bold',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansDefaultButton: {
    color: '#fff',
    background: "linear-gradient(-45deg, #ff0076, #ff4d2a)",
    fontSize: '1.2rem',
    borderRadius: '12px',
    width: '100%',
    textTransform: 'capitalize',
    fontWeight: '800',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
    '&:hover': {
      transform: 'scale(1.02)',
      boxShadow: '0 8px 16px #ff3343',
      borderColor: '#ff3343'
    }
  },
  tierPlansFeatureList: {
    padding: 0,
    textAlign: 'left',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansFeatureItem: {
    padding: '2px 0',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierPlansSeeAllFeatures: {
    textAlign: 'center',
    marginTop: '16px',
    color: '#e53935',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: 'bold',
    fontFamily: isRTL ? 'Heebo' : 'inherit',
  },
  tierInstruction: {
    fontFamily: isRTL ? 'Heebo' : 'inherit',
    fontSize: '1.3rem !important'
  },
  upgradeFlowContainer: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    height: '100%',
  },
  upgradeFlowTitle: {
    fontWeight: 'bold',
    color: '#e53935',
  },
  upgradeFlowFeatureCard: {
    borderRadius: '12px',
    height: '100%',
    background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#e4e4e4',
    borderLeft: 'solid 3px red',
  },
  upgradeFlowIncludingBox: {
    marginTop: '32px',
    padding: '16px',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #eee',
    borderRadius: '12px',
    background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#e4e4e4',
    borderTop: 'solid 3px red',
  },
  upgradeFlowPaymentForm: {
    padding: '24px',
    borderRadius: '12px',
  },
  upgradeFlowPrice: {
    color: '#e53935',
    fontWeight: 'bold',
  },
  upgradeFlowUpgradeButton: {
    marginTop: '24px',
    padding: '12px 0',
    borderRadius: '12px',
    background: 'linear-gradient(90deg, rgba(255,99,132,1) 0%, rgba(255,140,0,1) 100%)',
    color: 'white',
    fontWeight: 'bold',
  },
  upgradeFlowSupportCard: {
    padding: '16px',
    borderRadius: '12px',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fafafa',
    display: 'flex',
    alignItems: 'center',
  },
  tierPlansCurrencySymbol: {
    fontSize: '1.5rem',
    marginRight: '4px',
  },
  tierPlansStepper: {
    padding: '24px 0',
    height: '120px',
    '& .MuiStepIcon-root.MuiStepIcon-active': {
      color: '#e53935'
    },
    '& .MuiStepIcon-root.MuiStepIcon-completed': {
      color: '#e53935'
    }
  },
  tierPlansContent: {
    padding: '16px 24px',
    maxHeight: '78vh',
    // maxWidth: '1068px',
    paddingTop: '0px',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#4a5568',
    fontFamily: '"Heebo", sans-serif',
  },
  tierPlanFooter: {
    background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    textAlign: 'center',
    padding: '20px',
    borderRadius: 12,
    marginTop: 64
  },
  // Email Marketing Slider Styles
  emailMarketingSliderContainer: {
    padding: 24,
    background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#fff',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e2e8f0',
    borderRadius: 12,
    boxShadow: '0 2px 12px rgba(0, 0, 0, .06)'
  },
  // TierPlans popup only - added on top of the shared base slider class, which stays untouched.
  tierPlansEmailSliderContainerCompact: {
    padding: '14px !important',
  },
  sliderContainer: {
    position: 'relative',
    marginBottom: '48px',
    padding: '0px 8px'
  },
  // TierPlans-popup-only compact override - see note above.
  tierPlansSliderContainerCompact: {
    marginBottom: '24px !important',
  },
  sliderLabelsWrapper: {
    position: 'relative',
  },
  sliderLabelsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },
  sliderLabel: {
    cursor: 'pointer',
    position: 'absolute',
    transform: 'translateX(-50%)',
    transition: 'all 0.2s ease',
  },
  sliderLabelText: {
    fontSize: '14px',
    color: '#999',
    whiteSpace: 'nowrap',
    transform: 'scale(1)',
    transition: 'all 0.3s ease',
  },
  // sliderLabelActive: {
  //   fontSize: '16px !important',
  //   color: '#333 !important',
  //   transform: 'scale(1.1) !important',
  // },
  sliderTrackWrapper: {
    position: 'relative',
    paddingTop: '40px',
  },
  // TierPlans-popup-only compact override - see note above emailMarketingSliderContainer.
  tierPlansSliderTrackWrapperCompact: {
    paddingTop: '24px !important',
  },
  sliderTrack: {
    position: 'relative',
    height: '6px',
    backgroundColor: theme.palette.type === 'dark' ? '#4a505a' : '#e0e0e0',
    borderRadius: '3px',
  },
  sliderTrackFilled: {
    position: 'absolute',
    height: '6px',
    background: 'linear-gradient(-45deg, #ff0076, #ff4d2a)',
    borderRadius: '3px',
    transition: 'width 0.3s ease-out',
    left: 0,
  },
  sliderTrackFilledRTL: {
    left: 'auto',
    right: 0,
  },
  sliderThumb: {
    position: 'absolute',
    top: '50%',
    width: '20px',
    height: '20px',
    backgroundColor: '#ff4d2a',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    transition: 'all 0.3s ease-out',
    pointerEvents: 'none',
  },
  sliderInput: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer',
    zIndex: 10,
    WebkitAppearance: 'none',
    appearance: 'none',
  },
  sliderArrowLeft: {
    position: 'absolute',
    // top: '50%',
    transform: 'translateY(-40%)',
    left: '-24px', // Half of the button width to align at edge
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#ff4757',
    color: 'white !important',
    zIndex: 10,
    padding: 0,
    minWidth: 'unset',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: '#e63946',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    },
    '& svg': {
      fontSize: '18px',
      color: 'white',
    },
  },
  sliderArrowRight: {
    position: 'absolute',
    // top: '55%',
    transform: 'translateY(-65%)',
    right: '-24px',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#ff4757',
    color: 'white !important',
    zIndex: 10,
    padding: 0,
    minWidth: 'unset',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: '#e63946',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    },
    '& svg': {
      fontSize: '18px',
      color: 'white',
    },
  },
  tierPlanIconCont: {
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    background: '#ff8995',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      color: '#fff',
      fontSize: '14px'
    }
  },
  tooltipContent: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.tooltipSurface : '#000',
    color: theme.custom.tooltipSurfaceText,
    maxWidth: 440,
    padding: '6px 8px',
    boxSizing: 'border-box'
  },
  tooltipArrow: {
    color: theme.palette.type === 'dark' ? theme.custom.tooltipSurface : '#000'
  },
   pulseCheckbox: {
    padding: isRTL ? '4px 0px 4px 8px' : '4px 8px 4px 0px'
  },
  frozenCampaignsContainer: {
    marginBottom: safeTheme.spacing(3),
  },
  contactUsDialog: {
    width: 'auto !important',
    minWidth: '500px !important',
    maxWidth: '600px !important',
    '@media (max-width: 768px)': {
      minWidth: '400px !important',
      maxWidth: '500px !important',
    },
    '@media (max-width: 600px)': {
      minWidth: '350px !important',
      maxWidth: '450px !important',
    },
    '@media (max-width: 500px)': {
      minWidth: '350px !important',
      maxWidth: '400px !important',
    },
  },
  contactUsContent: {
    padding: '0px 8px',
    margin: '0px',
  },
  contactUsDialogContainer: {
    "& .MuiPaper-root": {
      overflowX: "hidden",
      width: 'auto',
      minWidth: '500px !important',
      maxWidth: '600px !important',
    },
    "& .MuiDialog-scrollPaper": {
      "@media screen and (max-width: 450px)": {
        zoom: '85%'
      },
      "@media screen and (max-width: 330px)": {
        zoom: '70%'
      }
    },
    "& .MuiDialog-paperWidthSm": {
      minWidth: '500px !important',
      maxWidth: '600px !important',
    },
    "& .MuiDialog-paperScrollPaper": {
      maxHeight: "100%",
      borderRadius: 15
    },
  },
  apiErrorDialogContainer: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: '600px !important',
      width: '100% !important',
      minWidth: 'unset !important',
      margin: '0 auto',
    },
  },
  textUnderlineDialogButton: {
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: 700,
    margin: isRTL ? '0px 5px 0px 0px' : '0px 0px 0px 5px',
    color: '#ff0076'
  },
  textColorHeading: {
    color: '#ff0076',
    fontWeight: 900,
  },
  contactUsCloseCont: {
    marginBottom: 8,
    borderRadius: '50%',
    width: 36,
    height: 36,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    '& svg': {
      width: 16,
      height: 16,
      padding: 10
    },
  },
  contactUsInputField: {
    maxWidth: 'auto',
    margin: '0 auto',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f5f5f5',
      '& fieldset': {
        borderColor: theme.palette.type === 'dark' ? theme.custom.border : '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.type === 'dark' ? theme.custom.border : '#bdbdbd',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 16px',
    },
  },
  contactUsTextField: {
    maxWidth: 'auto',
    margin: '0 auto',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f5f5f5',
      '& fieldset': {
        borderColor: theme.palette.type === 'dark' ? theme.custom.border : '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.type === 'dark' ? theme.custom.border : '#bdbdbd',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
    '& .MuiOutlinedInput-multiline': {
      padding: '12px',
    },
  },
  errorPlaceholder: {
    boxShadow: '0 1px 8px rgba(0, 0, 0, 0.15)',
    borderRadius: '12px',
    padding: 12,
    textAlign: 'center'
  },
  smallButton: {
    minHeight: 'auto',
    fontSize: '9px !important',
    padding: '0px 6px',
    minWidth: 'auto',
  },
  tierPlanBtn: {
    minHeight: 'auto',
    fontSize: '12px !important',
    fontWeight: 600,
    padding: '5px 16px !important',
    minWidth: '80px',
    whiteSpace: 'nowrap',
  },
  filterChip: {
    fontSize: '12px',
    // Dark: same surface as the theme's dark MuiChip; the light gradient painted over it and hid the white label (PR-3884).
    background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : 'linear-gradient(90deg, #ffffff 1.31%, #ffffff 33.07%, #ffffff 134.74%)',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#070707',
    border: '1px solid #FF3343',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    '& .MuiChip-label': {
      color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#070707',
      justifyContent: 'flex-start',
      textAlign: 'left',
      lineHeight: '1'
    },
    '& .MuiChip-deleteIcon': {
      color: '#FF3343'
    }
  },
  agentChip: {
    fontSize: '12px',
    // Dark: same surface as the theme's dark MuiChip; the light gradient painted over it and hid the white label (PR-3884).
    background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : 'linear-gradient(90deg, #ffffff 1.31%, #ffffff 33.07%, #ffffff 134.74%)',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#070707',
    border: '1px solid #FF3343',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    '& .MuiChip-label': {
      color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#070707',
      justifyContent: 'flex-start',
      textAlign: 'left',
      lineHeight: '1'
    },
    '& .MuiChip-deleteIcon': {
      color: '#FF3343'
    }
  },
  // Edit Tags Modal Styles
  editTagsDialogTitle: {
    backgroundColor: '#FF3343',
    color: '#fff',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    fontSize: '18px',
  },
  editTagsHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    minWidth: 0
  },
  editTagsIcon: {
    flexShrink: 0
  },
  editTagsHeaderText: {
    // fontSize: '16px',
    fontWeight: '600',
    whiteSpace: 'nowrap'
  },
  editTagsCloseIcon: {
    fontSize: '30px'
  },
  editTagsDialogContent: {
    padding: '20px',
    maxHeight: '500px',
    overflow: 'auto',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f9f9f9'
  },
  editTagsItem: {
    marginBottom: '16px',
    paddingBottom: '16px',
    borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0'
  },
  editTagsLabel: {
    fontSize: '14px',
    color: '#bbb',
    fontWeight: '600',
    marginBottom: '8px',
    display: 'block'
  },
  editTagsInputRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
    justifyContent: 'space-between'
  },
  editTagsTextField: {
    flex: 0.72,
    marginBottom: '0',
    '& .MuiOutlinedInput-root': {
      // fontSize: '13px',
      // padding: '5px 12px',
      borderRadius: '4px',
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff'
    },
    '& .MuiOutlinedInput-input': {
      // fontSize: '13px',
      // padding: '5px 12px',
      borderRadius: '4px',
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff'
    }
  },
  editTagsButtonsContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  editTagsUpdateButton: {
    borderColor: '#FF3343',
    color: '#FF3343',
    fontSize: '12px',
    padding: '6px 12px',
    textTransform: 'none',
    flexShrink: 0
  },
  editTagsDeleteButton: {
    color: '#FF3343',
    padding: '6px',
    flexShrink: 0
  },
  editTagsColorContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  editTagsColorCircle: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    cursor: 'pointer',
    border: '2px solid transparent',
    transition: 'border 0.2s',
    boxShadow: 'none',
    flexShrink: 0
  },
  editTagsColorCircleSelected: {
    border: '3px solid #333',
    boxShadow: '0 0 0 2px #fff'
  },
  editTagsAddNewTagBox: {
    marginTop: '10px',
    paddingTop: '10px',
    // borderTop: '1px solid #e0e0e0'
  },
  editTagsAddNewTagButton: {
    borderColor: '#FF3343',
    color: '#FF3343',
    padding: '10px',
    fontSize: '13px',
    textTransform: 'none',
    fontWeight: '600'
  },
  // Agent Management Buttons Wrapper
  agentManagementButtonsWrapper: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    flexDirection: isRTL ? 'row-reverse' : 'row',
    flexShrink: 0
  },
  // Start New Chat button in sidebar header — same color as manage agent icon (inherited)
  startNewChatIconButton: {
    padding: '6px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      borderRadius: '50%'
    }
  },
  // Start New Chat Modal styles
  startNewChatDialogTitle: {
    backgroundColor: '#FF3343',
    color: '#fff',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    fontSize: '18px'
  },
  startNewChatStepIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '10px 20px',
    borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0',
    backgroundColor: '#fafafa'
  },
  startNewChatStepDot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#ccc',
    transition: 'background-color 0.2s ease'
  },
  startNewChatStepDotActive: {
    backgroundColor: '#FF3343'
  },
  startNewChatDialogContent: {
    padding: '20px',
    minHeight: '220px',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f9f9f9'
  },
  startNewChatTemplateList: {
    maxHeight: '300px',
    overflowY: 'auto',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    borderRadius: '4px',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0'
  },
  startNewChatTemplateItem: {
    padding: '12px 16px',
    borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 23, 68, 0.08)' : '#fff3f4'
    },
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  startNewChatTemplateItemSelected: {
    backgroundColor: '#fff0f1',
    borderLeft: '3px solid #FF3343'
  },
  startNewChatSearchField: {
    width: '100%',
    marginBottom: '12px'
  },
  startNewChatVariableField: {
    width: '100%',
    marginBottom: '12px'
  },
  startNewChatPreviewBox: {
    backgroundColor: '#e5ddd5',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    fontFamily: 'inherit',
    fontSize: '14px'
  },
  startNewChatDisclaimerBox: {
    backgroundColor: '#fff8e1',
    border: '1px solid #ffe082',
    borderRadius: '4px',
    padding: '10px 14px',
    fontSize: '13px',
    direction: 'rtl',
    textAlign: 'right',
    color: '#5d4037',
    marginBottom: '8px'
  },
  startNewChatDialogActions: {
    padding: '12px 20px',
    borderTop: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0',
    justifyContent: 'space-between'
  },
  startNewChatNewTemplateButton: {
    color: '#FF3343',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    padding: '4px 8px',
    '&:hover': {
      backgroundColor: 'rgba(255, 51, 67, 0.08)'
    }
  },
  // Sidebar Header styling (WhatsApp chat contact-list header — named distinctly from
  // sideMenuStyle.js's own "sidebarHeader" key, which was silently overwriting this one
  // since both get spread into the same combined classes object in style/classes/index.js)
  whatsappSidebarHeader: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    padding: '8px',
    flexWrap: 'nowrap',
    flexDirection: isRTL ? 'row-reverse' : 'row',
    justifyContent: 'space-between',
    width: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box',
    '& > *': {
      flexShrink: 1,
      minWidth: 0
    },
    '& .chat__contact-wrapper': {
      flex: 1,
      minWidth: 0,
      overflow: 'hidden'
    }
  },
  // Chips Container - Keep tags and agent chip on same line
  chipsContainer: {
    display: 'flex',
    gap: '8px',
    padding: '8px 10px',
    alignItems: 'center',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    justifyContent: 'space-between',
    overflow: 'auto',
    flexWrap: 'nowrap'
  },
  // Inner chips wrapper - no wrap
  chipsWrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    flexWrap: 'nowrap',
    overflow: 'auto'
  },
  
  // ============ Chat UI Inline Styles ============
  // ChatUi.tsx styles
  tagChipsContainer: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    flexWrap: 'nowrap',
    overflowX: 'scroll',
    overflowY: 'hidden',
    minWidth: 0,
    width: 'fit-content',
    marginInlineEnd: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#888888 #e0e0e0',
    maxWidth: '83vw',
    '@media (min-width: 1025px)': {
      maxWidth: '16vw',
    },
    '@media (min-width: 1300px)': {
      maxWidth: '20vw',
    },
    '&::-webkit-scrollbar': {
      height: '2px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#e0e0e0',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888888',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555555',
    },
  },
  selectFieldStyle: {
    marginInline: 15
  },
  tagChipStyle: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f0f0f0',
    fontWeight: 600,
    fontSize: '11px',
    height: '22px',
    paddingTop: '9px', 
    paddingBottom: '9px',
    margin: '0 4px 0 0',
    borderRadius: '12px',
    '& svg': {
      color: '#fff',
    }
  },
  
  // ============ SideBarContactList Inline Styles ============
  // Tag and agent container
  tagAgentWrapper: {
    display: 'flex',
    gap: '4px',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    padding: '4px 0',
    justifyContent: 'space-between',
    minHeight: '32px'
  },
  tagsFlexWrapper: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    flexWrap: 'wrap',
    flex: 1,
    minWidth: 0,
    overflow: 'hidden', 
  },
  tagsScrollArea: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    flexWrap: 'nowrap',
    overflowX: 'scroll',
    overflowY: 'hidden',
    minWidth: 0,
    maxWidth: 'calc(100% - 28px)',
    scrollbarWidth: 'thin',
    scrollbarColor: '#888888 #e0e0e0',
    '&::-webkit-scrollbar': {
      height: '2px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#e0e0e0',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888888',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555555',
    },
  },
  tagChipSmall: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f0f0f0',
    color: '#fff',
    fontWeight: 600,
    fontSize: '9px',
    height: '18px',
    //padding: '0 5px',
    paddingTop: '8px',
    paddingBottom: '8px',
    margin: '0',
    '& svg': {
      color: '#fff',
    }
  },
  plusButtonStyle: {
    width: '22px',
    height: '22px',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f0f0f0',
    borderRadius: '50%',
    minWidth: '22px',
    padding: '2px',
    margin: '0',
    flexShrink: 0,
  },
  agentBoxContainer: {
    display: 'flex',
    gap: '4px',
    alignItems: 'flex-start',
    flexShrink: 0
  },
  agentNameBlack: {
    color: '#fff'
  },
  
  // Menu and MenuItem styles
  menuItemDisabled: {
    opacity: 0.7,
    fontWeight: 600
  },
  assignedTagMenuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 16px'
  },
  tagNameFlex: {
    flex: 1
  },
  deleteIconButton: {
    padding: 0,
    marginLeft: '8px'
  },
  tagMenuDivider: {
    borderTop: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #eee',
    margin: '8px 0'
  },
  availableTagMenuItem: {
    padding: '8px 16px'
  },
  tagColorDot: {
    color: 'inherit',
    fontWeight: 600
  },
  tagNameMargin: {
    marginLeft: '8px'
  },
  
  // ============ SideBar Inline Styles ============
  // Search and filter area
  searchAreaWrapper: {
    padding: '10px',
    // Same surface as the tab strips above it (both #f6f6f6 in light), so dark mode
    // no longer shows a separate band between the status tabs and the search bar.
    background: theme.palette.type === 'dark' ? theme.custom.surface : '#f6f6f6'
  },
  searchWrapperStyle: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    borderRadius: '4px',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0'
  },
  searchIconsStyle: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#999'
  },
  searchInputHidden: {
    display: 'none'
  },
  searchInputField: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    flex: 1,
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#333',
    fontSize: '14px'
  },
  searchWrapperComplex: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#FFF',
    borderRadius: '10px',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
    transition: 'all 0.3s ease'
  },
  searchIconsRight: {
    display: 'flex',
    gap: '8px',
    pointerEvents: 'none',
    alignItems: 'center'
  },
  iconButtonPointerAuto: {
    pointerEvents: 'auto'
  },
  iconButtonSmallPadding: {
    padding: '4px'
  },
  iconRedColor: {
    fontSize: '16px',
    color: '#FF3343'
  },
  iconGrayColor: {
    fontSize: '14px',
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#666'
  },
  
  // Filter dropdown
  filterDropdownWrapper: {
    padding: '10px',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f5f5f5',
    paddingTop: 3
  },
  filterFlexContainer: {
    display: 'flex',
    gap: '12px',
    flexDirection: isRTL => isRTL ? 'row-reverse' : 'row',
    alignItems: 'flex-end'
  },
  selectFieldFlexGrow: {
    flex: 1
  },
  selectFieldStyle2: {
    fontSize: '13px',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    padding: '8px 10px',
    borderRadius: '4px',
    height: '32px'
  },
  
  // Pagination
  paginationStyle: {
    borderTop: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #e0e0e0',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f9f9f9',
    paddingInline: 10,
    paddingTop: 0,
    paddingBottom: 0
  },
  dateFilterDialog: {
    padding: '20px'
  },
  
  // Date filter chips
  dateFilterChipsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  dateFilterChip: {
    width: '100%',
    height: '40px',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #ddd',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500'
  },
  dateInputsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    marginTop: '12px'
  },
  
  // Dialog header
  dialogHeaderStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px'
  },
  dialogCloseButton: {
    color: '#fff',
    padding: '0',
    position: 'absolute',
    right: '25px',
    top: '12px'
  },
  
  // Date filter content
  dateFilterContent: {
    marginBottom: '24px'
  },
  dateFilterTitle: {
    margin: '0 0 12px 0',
    fontSize: '14px',
    fontWeight: '600',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#333'
  },
  dateRangeSection: {
    marginBottom: '24px'
  },
  dateRangeHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px'
  },
  dateRangeTitle: {
    margin: '0',
    fontSize: '14px',
    fontWeight: '600',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#333'
  },
  dateChipContainer: {
    width: '100%',
    height: '40px',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #ddd',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500'
  },
  chatHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f0f2f5',
    borderBottom: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #d1d7db'
  },
  chatAvatarWrapper: {
    marginRight: '12px'
  },
  chatContactWrapper: {
    flex: '0 0 auto',
    marginRight: '16px'
  },
  chatContactName: {
    fontSize: '16px',
    fontWeight: 500,
    margin: 0
  },
  chatContactDesc: {
    fontSize: '13px',
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#667781',
    margin: 0
  },
  // Display Conditions Dialog Styles
  displayConditionMainContainer: {
    padding: '0px',
  },
  displayConditionLabelTypography: {
    fontWeight: 600,
    marginBottom: 4,
    padding: '0px',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#333',
    fontSize: '15px',
  },
  displayConditionInputRow: {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
  },
  displayConditionMatchLabel: {
    fontSize: 15,
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#555',
    fontWeight: 500,
  },
  displayConditionMatchFormControl: {
    minWidth: 100,
  },
  displayConditionMatchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
  },
  displayConditionAddButton: {
    textTransform: 'none',
    fontWeight: 500,
    marginLeft: '8px',
    fontSize: 15,
  },
  displayConditionFieldFormControl: {
    width: 180,
  },
  displayConditionMenuItem: {
    fontSize: 15,
  },
  displayConditionOperatorFormControl: {
    width: 150,
  },
  displayConditionValueTextField: {
    width: 180,
  },
  displayConditionPreviewBox: {
    fontSize: 18,
    backgroundColor: '#f9fafb',
    borderRadius: 8,
    padding: 16,
    height: 'fit-content',
    border: '1px solid #e5e7eb',
  },
  displayConditionPreviewTitle: {
    fontWeight: 600,
    marginBottom: 12,
    color: '#6b7280',
    letterSpacing: 0.5,
    fontSize: '20px',
  },
  displayConditionPreviewContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  displayConditionPreviewItemBox: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 20,
    gap: 3,
  },
  displayConditionPreviewCaption: {
    fontSize: 20,
    color: '#9ca3af',
    textTransform: 'uppercase',
    fontWeight: 600,
  },
  displayConditionPreviewBody: {
    fontSize: 20,
    color: '#111827',
  },
  displayConditionCodeBox: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#eef2f7',
    padding: '6px 10px',
    borderRadius: 4,
    fontFamily: 'monospace',
    fontSize: 20,
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#374151',
    marginTop: 3,
  },
  // INNER paper (BaseDialog's <Paper>, via paperStyle): FILLS the outer paper exactly so it can
  // never overflow it in either direction — the actual width lives on the OUTER paper
  // (tierGraphDialogContainer). inner margin-box == outer content box => overflowX:hidden has
  // nothing to clip, in RTL or LTR, at any viewport.
  tierGraphDialogPaperProps: {
    borderRadius: 15,
    padding: '0px',
    width: '100%',
    maxWidth: '100% !important',
    minWidth: '0 !important',
    maxHeight: '92vh',
    margin: '0 !important',        // gutter comes solely from the outer paper (no double margin)
    boxSizing: 'border-box',
    overflow: 'hidden',
    // undo the app-wide "::placeholder { color: red }" leak (Whatsapp/Chat/css/overrides.css) — scope a
    // neutral placeholder color to this dialog only. Higher specificity beats the global rule.
    '& input::placeholder': { color: '#9aa1ad', opacity: 1 },
    '& input::-ms-input-placeholder': { color: '#9aa1ad' },
  },
  // reclaim dialogContent's residual 1rem side margin + minWidth so the graph is full-bleed
  tierGraphDialogContent: {
    border: 'none !important',
    margin: '0 !important',
    padding: '0 !important',
    minWidth: '0 !important',
    width: '100%',
    boxSizing: 'border-box',
  },
  // reclaim dialogChildren's marginBlock / summaryPadding (overflowY stays auto for tall dialogs)
  tierGraphDialogChildren: {
    margin: '0 !important',
    marginBlock: '0 !important',
    padding: '0 !important',
    minWidth: '0 !important',
    overflowX: 'hidden',
  },
  displayConditionDialogPaperProps: {
    borderRadius: 8,
    padding: '0px',
    minWidth: '900px !important',
    maxWidth: '1000px !important',
    width: '900px !important',
  },
  displayConditionConditionNameBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  displayConditionMatchBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: 6,
  },
  displayConditionRulesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: 6,
  },
  displayConditionRuleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  displayConditionDeleteButton: {
    minWidth: '20px',
    width: '20px',
    height: '20px',
    padding: 0,
  },
  displayConditionCustomStyle: {
    minWidth: '600px !important'
  },
  Button_button_l: {
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: 6,
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  Button_solid_l: {
    background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
    color: '#fff',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(255, 0, 76, 0.3)',
    },
  },
  Button_solid_m: {
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 600,
    borderRadius: '6px',
    background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  Button_solid_s: {
    padding: '8px 16px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '4px',
    background: 'linear-gradient(90deg, #FF0076 0%, #FF0054 23.8%, #FF4D2A 100%)',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  Button_secondary_l: {
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: 600,
    borderRadius: '8px',
    background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    color: '#FF0076',
    border: '2px solid #FF0076',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: '#FF0076',
      color: '#fff',
    },
  },
  Button_secondary_m: {
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 600,
    borderRadius: '6px',
    background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    color: '#FF0076',
    border: '2px solid #FF0076',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  Button_secondary_s: {
    padding: '8px 16px',
    fontSize: '15px',
    fontWeight: 600,
    borderRadius: '4px',
    background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
    color: '#FF0076',
    border: '2px solid #FF0076',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  Button_disabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
  displayConditionButtons: {
    minWidth: '140px !important',
    width: '140px !important',
  },
  displayConditionPaperProps: {
    minWidth: '1000px !important',
    width: '1000px !important',
    maxWidth: '1000px !important',
    overflow: 'hidden'
  },
  displayConditionMainBox: {
    padding: '0px',
  },
  displayConditionGridContainer: {
    overflow: 'hidden'
  },
  displayConditionLeftGrid: {
    overflow: 'hidden'
  },
  displayConditionRightGrid: {
    overflow: 'hidden'
  },
  displayConditionRulesBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxWidth: '100%',
    overflow: 'hidden'
  },
  displayConditionRuleRow: {
    display: 'grid',
    gridTemplateColumns: '150px 130px 180px 50px',
    gap: '8px',
    alignItems: 'flex-start',
    overflow: 'hidden',
  },
  displayConditionTextFieldBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '160px',
    overflow: 'hidden',
    minWidth: 0,
  },
  displayConditionTextFieldStyle: {
    overflow: 'hidden',
    width: '100%'
  },
  displayConditionPreviewBoxStyle: {
    maxHeight: '450px',
    fontSize: 18,
    overflowY: 'auto',
    overflow: 'hidden'
  },
  displayConditionMatchTypeBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    marginBottom: '12px',
    overflow: 'hidden'
  },
  displayConditionAddButton: {
    textTransform: 'none',
    marginLeft: isRTL ? 'auto' : '0px',
    marginRight: !isRTL ? 'auto' : '0px'
  },
  filterInputLabelSpan: {
    display: 'inline-block',
    marginTop: 2,
  },
  filterTimeframeBox: {
    marginRight: isRTL ? 'auto' : 'unset',
    marginLeft: !isRTL ? 'auto' : 'unset',
    alignItems: 'center',
  },
  filterTimeframeFormControl: {
    marginInlineStart: 8,
    minWidth: 90,
  },
  // Desktop TopMenu styles
  topMenu: {
    display: 'flex',
    gap: 15,
    paddingBottom: 2,
    paddingTop: 5,
    marginInlineEnd: 20,
    marginBottom: 0,
    justifyContent: 'flex-end',
    alignItems: 'center',
    backgroundColor: `${theme.custom.toolbarBackground} !important`,
    background: `${theme.custom.toolbarBackground} !important`,
    position: 'relative',
    zIndex: 1,
    minHeight: 40,
    '& > *': {
      flexShrink: 0,
      minWidth: 'auto'
    },
    ...(theme.palette.type === 'dark' ? { borderBottom: `1px solid ${theme.custom.border}`, paddingBottom: 6 } : {}),
  },

  // Mobile TopMenu styles
  mobileTopMenu: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: 56,
    backgroundColor: theme.custom.toolbarBackground,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    zIndex: 1200,
    justifyContent: 'space-between',
    marginBlock: 0,
    gap: 8
  },
  
  mobileHamburgerButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.04)'
    }
  },
  
  mobileRightItems: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  
  desktopRightItems: {
    display: 'flex',
    alignItems: 'center',
    gap: 15,
    '& > *': {
      flexShrink: 0
    }
  },
  backToAdminButton: {
    padding: '6px 16px',
    borderRadius: 50,
    background: `linear-gradient(90deg, ${theme.custom.toolbarAccentStop1} 0%, ${theme.custom.toolbarAccentStop2} 23.8%, ${theme.custom.toolbarAccentStop3} 100%)`,
    color: theme.custom.toolbarAccentContrast,
    fontWeight: 600,
    fontSize: '0.85rem',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      background: `linear-gradient(90deg, ${theme.custom.toolbarAccentStop1} 0%, ${theme.custom.toolbarAccentStop2} 23.8%, ${theme.custom.toolbarAccentStop3} 100%)`,
      opacity: 0.9,
    },
  }
});
}
